// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27white%27 stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27white%27 stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jost:wght@100;200;300;400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Primary Colors*/
/*Accent Colors*/
.university-0 {
  background-color: #51499C !important;
}
.university-0::after {
  content: "#51499C";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-10 {
  background-color: #49428c !important;
}
.university-10::after {
  content: "#49428c";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-20 {
  background-color: #413a7d !important;
}
.university-20::after {
  content: "#413a7d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-30 {
  background-color: #39336d !important;
}
.university-30::after {
  content: "#39336d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-40 {
  background-color: #312c5e !important;
}
.university-40::after {
  content: "#312c5e";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-50 {
  background-color: #29254e !important;
}
.university-50::after {
  content: "#29254e";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-60 {
  background-color: #201d3e !important;
}
.university-60::after {
  content: "#201d3e";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-70 {
  background-color: #18162f !important;
}
.university-70::after {
  content: "#18162f";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-80 {
  background-color: #100f1f !important;
}
.university-80::after {
  content: "#100f1f";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-90 {
  background-color: #080710 !important;
}
.university-90::after {
  content: "#080710";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-100 {
  background-color: #000000 !important;
}
.university-100::after {
  content: "#000000";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-0 {
  background-color: #51499c !important;
}
.university-lite-0::after {
  content: "#51499c";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-10 {
  background-color: #625ba6 !important;
}
.university-lite-10::after {
  content: "#625ba6";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-20 {
  background-color: #746db0 !important;
}
.university-lite-20::after {
  content: "#746db0";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-30 {
  background-color: #8580ba !important;
}
.university-lite-30::after {
  content: "#8580ba";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-40 {
  background-color: #9792c4 !important;
}
.university-lite-40::after {
  content: "#9792c4";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-50 {
  background-color: #a8a4ce !important;
}
.university-lite-50::after {
  content: "#a8a4ce";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-60 {
  background-color: #b9b6d7 !important;
}
.university-lite-60::after {
  content: "#b9b6d7";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-70 {
  background-color: #cbc8e1 !important;
}
.university-lite-70::after {
  content: "#cbc8e1";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-80 {
  background-color: #dcdbeb !important;
}
.university-lite-80::after {
  content: "#dcdbeb";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-90 {
  background-color: #eeedf5 !important;
}
.university-lite-90::after {
  content: "#eeedf5";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-100 {
  background-color: #ffffff !important;
}
.university-lite-100::after {
  content: "#ffffff";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-0 {
  background-color: #5cae48 !important;
}
.primaryGreen-0::after {
  content: "#5cae48";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-10 {
  background-color: #539d41 !important;
}
.primaryGreen-10::after {
  content: "#539d41";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-20 {
  background-color: #4a8b3a !important;
}
.primaryGreen-20::after {
  content: "#4a8b3a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-30 {
  background-color: #407a32 !important;
}
.primaryGreen-30::after {
  content: "#407a32";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-40 {
  background-color: #37682b !important;
}
.primaryGreen-40::after {
  content: "#37682b";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-50 {
  background-color: #2e5724 !important;
}
.primaryGreen-50::after {
  content: "#2e5724";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-60 {
  background-color: #25461d !important;
}
.primaryGreen-60::after {
  content: "#25461d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-70 {
  background-color: #1c3416 !important;
}
.primaryGreen-70::after {
  content: "#1c3416";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-80 {
  background-color: #12230e !important;
}
.primaryGreen-80::after {
  content: "#12230e";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-90 {
  background-color: #091107 !important;
}
.primaryGreen-90::after {
  content: "#091107";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-100 {
  background-color: #000000 !important;
}
.primaryGreen-100::after {
  content: "#000000";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-0 {
  background-color: #5cae48 !important;
}
.primaryGreen-lite-0::after {
  content: "#5cae48";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-10 {
  background-color: #6cb65a !important;
}
.primaryGreen-lite-10::after {
  content: "#6cb65a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-20 {
  background-color: #7dbe6d !important;
}
.primaryGreen-lite-20::after {
  content: "#7dbe6d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-30 {
  background-color: #8dc67f !important;
}
.primaryGreen-lite-30::after {
  content: "#8dc67f";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-40 {
  background-color: #9dce91 !important;
}
.primaryGreen-lite-40::after {
  content: "#9dce91";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-50 {
  background-color: #aed7a4 !important;
}
.primaryGreen-lite-50::after {
  content: "#aed7a4";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-60 {
  background-color: #bedfb6 !important;
}
.primaryGreen-lite-60::after {
  content: "#bedfb6";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-70 {
  background-color: #cee7c8 !important;
}
.primaryGreen-lite-70::after {
  content: "#cee7c8";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-80 {
  background-color: #deefda !important;
}
.primaryGreen-lite-80::after {
  content: "#deefda";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-90 {
  background-color: #eff7ed !important;
}
.primaryGreen-lite-90::after {
  content: "#eff7ed";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-100 {
  background-color: #ffffff !important;
}
.primaryGreen-lite-100::after {
  content: "#ffffff";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-0 {
  background-color: #26a7df !important;
}
.schools-0::after {
  content: "#26a7df";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-10 {
  background-color: #2296c9 !important;
}
.schools-10::after {
  content: "#2296c9";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-20 {
  background-color: #1e86b2 !important;
}
.schools-20::after {
  content: "#1e86b2";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-30 {
  background-color: #1b759c !important;
}
.schools-30::after {
  content: "#1b759c";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-40 {
  background-color: #176486 !important;
}
.schools-40::after {
  content: "#176486";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-50 {
  background-color: #135470 !important;
}
.schools-50::after {
  content: "#135470";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-60 {
  background-color: #0f4359 !important;
}
.schools-60::after {
  content: "#0f4359";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-70 {
  background-color: #0b3243 !important;
}
.schools-70::after {
  content: "#0b3243";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-80 {
  background-color: #08212d !important;
}
.schools-80::after {
  content: "#08212d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-90 {
  background-color: #041116 !important;
}
.schools-90::after {
  content: "#041116";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-100 {
  background-color: #000000 !important;
}
.schools-100::after {
  content: "#000000";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-0 {
  background-color: #26a7df !important;
}
.schools-lite-0::after {
  content: "#26a7df";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-10 {
  background-color: #3cb0e2 !important;
}
.schools-lite-10::after {
  content: "#3cb0e2";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-20 {
  background-color: #51b9e5 !important;
}
.schools-lite-20::after {
  content: "#51b9e5";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-30 {
  background-color: #67c1e9 !important;
}
.schools-lite-30::after {
  content: "#67c1e9";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-40 {
  background-color: #7dcaec !important;
}
.schools-lite-40::after {
  content: "#7dcaec";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-50 {
  background-color: #93d3ef !important;
}
.schools-lite-50::after {
  content: "#93d3ef";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-60 {
  background-color: #a8dcf2 !important;
}
.schools-lite-60::after {
  content: "#a8dcf2";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-70 {
  background-color: #bee5f5 !important;
}
.schools-lite-70::after {
  content: "#bee5f5";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-80 {
  background-color: #d4edf9 !important;
}
.schools-lite-80::after {
  content: "#d4edf9";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-90 {
  background-color: #e9f6fc !important;
}
.schools-lite-90::after {
  content: "#e9f6fc";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-100 {
  background-color: #ffffff !important;
}
.schools-lite-100::after {
  content: "#ffffff";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-0 {
  background-color: #003457 !important;
}
.primaryDarkBlue-0::after {
  content: "#003457";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-10 {
  background-color: #002f4e !important;
}
.primaryDarkBlue-10::after {
  content: "#002f4e";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-20 {
  background-color: #002a46 !important;
}
.primaryDarkBlue-20::after {
  content: "#002a46";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-30 {
  background-color: #00243d !important;
}
.primaryDarkBlue-30::after {
  content: "#00243d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-40 {
  background-color: #001f34 !important;
}
.primaryDarkBlue-40::after {
  content: "#001f34";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-50 {
  background-color: #001a2c !important;
}
.primaryDarkBlue-50::after {
  content: "#001a2c";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-60 {
  background-color: #001523 !important;
}
.primaryDarkBlue-60::after {
  content: "#001523";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-70 {
  background-color: #00101a !important;
}
.primaryDarkBlue-70::after {
  content: "#00101a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-80 {
  background-color: #000a11 !important;
}
.primaryDarkBlue-80::after {
  content: "#000a11";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-90 {
  background-color: #000509 !important;
}
.primaryDarkBlue-90::after {
  content: "#000509";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-100 {
  background-color: #000000 !important;
}
.primaryDarkBlue-100::after {
  content: "#000000";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-0 {
  background-color: #003457 !important;
}
.primaryDarkBlue-lite-0::after {
  content: "#003457";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-10 {
  background-color: #1a4868 !important;
}
.primaryDarkBlue-lite-10::after {
  content: "#1a4868";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-20 {
  background-color: #335d79 !important;
}
.primaryDarkBlue-lite-20::after {
  content: "#335d79";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-30 {
  background-color: #4d7189 !important;
}
.primaryDarkBlue-lite-30::after {
  content: "#4d7189";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-40 {
  background-color: #66859a !important;
}
.primaryDarkBlue-lite-40::after {
  content: "#66859a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-50 {
  background-color: #809aab !important;
}
.primaryDarkBlue-lite-50::after {
  content: "#809aab";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-60 {
  background-color: #99aebc !important;
}
.primaryDarkBlue-lite-60::after {
  content: "#99aebc";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-70 {
  background-color: #b3c2cd !important;
}
.primaryDarkBlue-lite-70::after {
  content: "#b3c2cd";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-80 {
  background-color: #ccd6dd !important;
}
.primaryDarkBlue-lite-80::after {
  content: "#ccd6dd";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-90 {
  background-color: #ecebee !important;
}
.primaryDarkBlue-lite-90::after {
  content: "#ecebee";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-100 {
  background-color: #ffffff !important;
}
.primaryDarkBlue-lite-100::after {
  content: "#ffffff";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-0 {
  background-color: #d42941 !important;
}
.alumni-0::after {
  content: "#d42941";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-10 {
  background-color: #bf253b !important;
}
.alumni-10::after {
  content: "#bf253b";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-20 {
  background-color: #aa2134 !important;
}
.alumni-20::after {
  content: "#aa2134";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-30 {
  background-color: #941d2e !important;
}
.alumni-30::after {
  content: "#941d2e";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-40 {
  background-color: #7f1927 !important;
}
.alumni-40::after {
  content: "#7f1927";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-50 {
  background-color: #6a1521 !important;
}
.alumni-50::after {
  content: "#6a1521";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-60 {
  background-color: #55101a !important;
}
.alumni-60::after {
  content: "#55101a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-70 {
  background-color: #400c13 !important;
}
.alumni-70::after {
  content: "#400c13";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-80 {
  background-color: #2a080d !important;
}
.alumni-80::after {
  content: "#2a080d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-90 {
  background-color: #150406 !important;
}
.alumni-90::after {
  content: "#150406";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-100 {
  background-color: #000000 !important;
}
.alumni-100::after {
  content: "#000000";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-0 {
  background-color: #d42941 !important;
}
.alumni-lite-0::after {
  content: "#d42941";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-10 {
  background-color: #d83e54 !important;
}
.alumni-lite-10::after {
  content: "#d83e54";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-20 {
  background-color: #dd5467 !important;
}
.alumni-lite-20::after {
  content: "#dd5467";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-30 {
  background-color: #e1697a !important;
}
.alumni-lite-30::after {
  content: "#e1697a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-40 {
  background-color: #e57f8d !important;
}
.alumni-lite-40::after {
  content: "#e57f8d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-50 {
  background-color: #ea94a0 !important;
}
.alumni-lite-50::after {
  content: "#ea94a0";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-60 {
  background-color: #eea9b3 !important;
}
.alumni-lite-60::after {
  content: "#eea9b3";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-70 {
  background-color: #f2bfc6 !important;
}
.alumni-lite-70::after {
  content: "#f2bfc6";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-80 {
  background-color: #f6d4d9 !important;
}
.alumni-lite-80::after {
  content: "#f6d4d9";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-90 {
  background-color: #fbeaec !important;
}
.alumni-lite-90::after {
  content: "#fbeaec";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-100 {
  background-color: #ffffff !important;
}
.alumni-lite-100::after {
  content: "#ffffff";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-0 {
  background-color: #f05a2a !important;
}
.counsellors-0::after {
  content: "#f05a2a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-10 {
  background-color: #d85126 !important;
}
.counsellors-10::after {
  content: "#d85126";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-20 {
  background-color: #c04822 !important;
}
.counsellors-20::after {
  content: "#c04822";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-30 {
  background-color: #a83f1d !important;
}
.counsellors-30::after {
  content: "#a83f1d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-40 {
  background-color: #903619 !important;
}
.counsellors-40::after {
  content: "#903619";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-50 {
  background-color: #782d15 !important;
}
.counsellors-50::after {
  content: "#782d15";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-60 {
  background-color: #602411 !important;
}
.counsellors-60::after {
  content: "#602411";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-70 {
  background-color: #481b0d !important;
}
.counsellors-70::after {
  content: "#481b0d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-80 {
  background-color: #301208 !important;
}
.counsellors-80::after {
  content: "#301208";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-90 {
  background-color: #180904 !important;
}
.counsellors-90::after {
  content: "#180904";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-100 {
  background-color: #000000 !important;
}
.counsellors-100::after {
  content: "#000000";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-0 {
  background-color: #f05a2a !important;
}
.counsellors-lite-0::after {
  content: "#f05a2a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-10 {
  background-color: #f26b3f !important;
}
.counsellors-lite-10::after {
  content: "#f26b3f";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-20 {
  background-color: #f37b55 !important;
}
.counsellors-lite-20::after {
  content: "#f37b55";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-30 {
  background-color: #f58c6a !important;
}
.counsellors-lite-30::after {
  content: "#f58c6a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-40 {
  background-color: #f69c7f !important;
}
.counsellors-lite-40::after {
  content: "#f69c7f";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-50 {
  background-color: #f8ad95 !important;
}
.counsellors-lite-50::after {
  content: "#f8ad95";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-60 {
  background-color: #f9bdaa !important;
}
.counsellors-lite-60::after {
  content: "#f9bdaa";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-70 {
  background-color: #fbcebf !important;
}
.counsellors-lite-70::after {
  content: "#fbcebf";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-80 {
  background-color: #fcded4 !important;
}
.counsellors-lite-80::after {
  content: "#fcded4";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-90 {
  background-color: #feefea !important;
}
.counsellors-lite-90::after {
  content: "#feefea";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-100 {
  background-color: #ffffff !important;
}
.counsellors-lite-100::after {
  content: "#ffffff";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-0 {
  background-color: #f8b018 !important;
}
.students-0::after {
  content: "#f8b018";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-10 {
  background-color: #df9e16 !important;
}
.students-10::after {
  content: "#df9e16";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-20 {
  background-color: #c68d13 !important;
}
.students-20::after {
  content: "#c68d13";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-30 {
  background-color: #ae7b11 !important;
}
.students-30::after {
  content: "#ae7b11";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-40 {
  background-color: #956a0e !important;
}
.students-40::after {
  content: "#956a0e";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-50 {
  background-color: #7c580c !important;
}
.students-50::after {
  content: "#7c580c";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-60 {
  background-color: #63460a !important;
}
.students-60::after {
  content: "#63460a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-70 {
  background-color: #4a3507 !important;
}
.students-70::after {
  content: "#4a3507";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-80 {
  background-color: #322305 !important;
}
.students-80::after {
  content: "#322305";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-90 {
  background-color: #191202 !important;
}
.students-90::after {
  content: "#191202";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-100 {
  background-color: #000000 !important;
}
.students-100::after {
  content: "#000000";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-0 {
  background-color: #f8b018 !important;
}
.students-lite-0::after {
  content: "#f8b018";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-10 {
  background-color: #f9b82f !important;
}
.students-lite-10::after {
  content: "#f9b82f";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-20 {
  background-color: #f9c046 !important;
}
.students-lite-20::after {
  content: "#f9c046";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-30 {
  background-color: #fac85d !important;
}
.students-lite-30::after {
  content: "#fac85d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-40 {
  background-color: #fbd074 !important;
}
.students-lite-40::after {
  content: "#fbd074";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-50 {
  background-color: #fcd88c !important;
}
.students-lite-50::after {
  content: "#fcd88c";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-60 {
  background-color: #fcdfa3 !important;
}
.students-lite-60::after {
  content: "#fcdfa3";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-70 {
  background-color: #fde7ba !important;
}
.students-lite-70::after {
  content: "#fde7ba";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-80 {
  background-color: #feefd1 !important;
}
.students-lite-80::after {
  content: "#feefd1";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-90 {
  background-color: #fef7e8 !important;
}
.students-lite-90::after {
  content: "#fef7e8";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-100 {
  background-color: #ffffff !important;
}
.students-lite-100::after {
  content: "#ffffff";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-0 {
  background-color: #f8b018 !important;
}
.parents-0::after {
  content: "#f8b018";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-10 {
  background-color: #df9e16 !important;
}
.parents-10::after {
  content: "#df9e16";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-20 {
  background-color: #c68d13 !important;
}
.parents-20::after {
  content: "#c68d13";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-30 {
  background-color: #ae7b11 !important;
}
.parents-30::after {
  content: "#ae7b11";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-40 {
  background-color: #956a0e !important;
}
.parents-40::after {
  content: "#956a0e";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-50 {
  background-color: #7c580c !important;
}
.parents-50::after {
  content: "#7c580c";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-60 {
  background-color: #63460a !important;
}
.parents-60::after {
  content: "#63460a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-70 {
  background-color: #4a3507 !important;
}
.parents-70::after {
  content: "#4a3507";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-80 {
  background-color: #322305 !important;
}
.parents-80::after {
  content: "#322305";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-90 {
  background-color: #191202 !important;
}
.parents-90::after {
  content: "#191202";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-100 {
  background-color: #000000 !important;
}
.parents-100::after {
  content: "#000000";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-0 {
  background-color: #f8b018 !important;
}
.parents-lite-0::after {
  content: "#f8b018";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-10 {
  background-color: #f9b82f !important;
}
.parents-lite-10::after {
  content: "#f9b82f";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-20 {
  background-color: #f9c046 !important;
}
.parents-lite-20::after {
  content: "#f9c046";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-30 {
  background-color: #fac85d !important;
}
.parents-lite-30::after {
  content: "#fac85d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-40 {
  background-color: #fbd074 !important;
}
.parents-lite-40::after {
  content: "#fbd074";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-50 {
  background-color: #fcd88c !important;
}
.parents-lite-50::after {
  content: "#fcd88c";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-60 {
  background-color: #fcdfa3 !important;
}
.parents-lite-60::after {
  content: "#fcdfa3";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-70 {
  background-color: #fde7ba !important;
}
.parents-lite-70::after {
  content: "#fde7ba";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-80 {
  background-color: #feefd1 !important;
}
.parents-lite-80::after {
  content: "#feefd1";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-90 {
  background-color: #fef7e8 !important;
}
.parents-lite-90::after {
  content: "#fef7e8";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-100 {
  background-color: #ffffff !important;
}
.parents-lite-100::after {
  content: "#ffffff";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

/*Primary Colors*/
/*Accent Colors*/
.university-0 {
  background-color: #51499C !important;
}
.university-0::after {
  content: "#51499C";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-10 {
  background-color: #49428c !important;
}
.university-10::after {
  content: "#49428c";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-20 {
  background-color: #413a7d !important;
}
.university-20::after {
  content: "#413a7d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-30 {
  background-color: #39336d !important;
}
.university-30::after {
  content: "#39336d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-40 {
  background-color: #312c5e !important;
}
.university-40::after {
  content: "#312c5e";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-50 {
  background-color: #29254e !important;
}
.university-50::after {
  content: "#29254e";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-60 {
  background-color: #201d3e !important;
}
.university-60::after {
  content: "#201d3e";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-70 {
  background-color: #18162f !important;
}
.university-70::after {
  content: "#18162f";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-80 {
  background-color: #100f1f !important;
}
.university-80::after {
  content: "#100f1f";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-90 {
  background-color: #080710 !important;
}
.university-90::after {
  content: "#080710";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-100 {
  background-color: #000000 !important;
}
.university-100::after {
  content: "#000000";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-0 {
  background-color: #51499c !important;
}
.university-lite-0::after {
  content: "#51499c";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-10 {
  background-color: #625ba6 !important;
}
.university-lite-10::after {
  content: "#625ba6";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-20 {
  background-color: #746db0 !important;
}
.university-lite-20::after {
  content: "#746db0";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-30 {
  background-color: #8580ba !important;
}
.university-lite-30::after {
  content: "#8580ba";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-40 {
  background-color: #9792c4 !important;
}
.university-lite-40::after {
  content: "#9792c4";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-50 {
  background-color: #a8a4ce !important;
}
.university-lite-50::after {
  content: "#a8a4ce";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-60 {
  background-color: #b9b6d7 !important;
}
.university-lite-60::after {
  content: "#b9b6d7";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-70 {
  background-color: #cbc8e1 !important;
}
.university-lite-70::after {
  content: "#cbc8e1";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-80 {
  background-color: #dcdbeb !important;
}
.university-lite-80::after {
  content: "#dcdbeb";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-90 {
  background-color: #eeedf5 !important;
}
.university-lite-90::after {
  content: "#eeedf5";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.university-lite-100 {
  background-color: #ffffff !important;
}
.university-lite-100::after {
  content: "#ffffff";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-0 {
  background-color: #5cae48 !important;
}
.primaryGreen-0::after {
  content: "#5cae48";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-10 {
  background-color: #539d41 !important;
}
.primaryGreen-10::after {
  content: "#539d41";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-20 {
  background-color: #4a8b3a !important;
}
.primaryGreen-20::after {
  content: "#4a8b3a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-30 {
  background-color: #407a32 !important;
}
.primaryGreen-30::after {
  content: "#407a32";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-40 {
  background-color: #37682b !important;
}
.primaryGreen-40::after {
  content: "#37682b";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-50 {
  background-color: #2e5724 !important;
}
.primaryGreen-50::after {
  content: "#2e5724";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-60 {
  background-color: #25461d !important;
}
.primaryGreen-60::after {
  content: "#25461d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-70 {
  background-color: #1c3416 !important;
}
.primaryGreen-70::after {
  content: "#1c3416";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-80 {
  background-color: #12230e !important;
}
.primaryGreen-80::after {
  content: "#12230e";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-90 {
  background-color: #091107 !important;
}
.primaryGreen-90::after {
  content: "#091107";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-100 {
  background-color: #000000 !important;
}
.primaryGreen-100::after {
  content: "#000000";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-0 {
  background-color: #5cae48 !important;
}
.primaryGreen-lite-0::after {
  content: "#5cae48";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-10 {
  background-color: #6cb65a !important;
}
.primaryGreen-lite-10::after {
  content: "#6cb65a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-20 {
  background-color: #7dbe6d !important;
}
.primaryGreen-lite-20::after {
  content: "#7dbe6d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-30 {
  background-color: #8dc67f !important;
}
.primaryGreen-lite-30::after {
  content: "#8dc67f";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-40 {
  background-color: #9dce91 !important;
}
.primaryGreen-lite-40::after {
  content: "#9dce91";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-50 {
  background-color: #aed7a4 !important;
}
.primaryGreen-lite-50::after {
  content: "#aed7a4";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-60 {
  background-color: #bedfb6 !important;
}
.primaryGreen-lite-60::after {
  content: "#bedfb6";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-70 {
  background-color: #cee7c8 !important;
}
.primaryGreen-lite-70::after {
  content: "#cee7c8";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-80 {
  background-color: #deefda !important;
}
.primaryGreen-lite-80::after {
  content: "#deefda";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-90 {
  background-color: #eff7ed !important;
}
.primaryGreen-lite-90::after {
  content: "#eff7ed";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryGreen-lite-100 {
  background-color: #ffffff !important;
}
.primaryGreen-lite-100::after {
  content: "#ffffff";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-0 {
  background-color: #26a7df !important;
}
.schools-0::after {
  content: "#26a7df";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-10 {
  background-color: #2296c9 !important;
}
.schools-10::after {
  content: "#2296c9";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-20 {
  background-color: #1e86b2 !important;
}
.schools-20::after {
  content: "#1e86b2";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-30 {
  background-color: #1b759c !important;
}
.schools-30::after {
  content: "#1b759c";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-40 {
  background-color: #176486 !important;
}
.schools-40::after {
  content: "#176486";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-50 {
  background-color: #135470 !important;
}
.schools-50::after {
  content: "#135470";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-60 {
  background-color: #0f4359 !important;
}
.schools-60::after {
  content: "#0f4359";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-70 {
  background-color: #0b3243 !important;
}
.schools-70::after {
  content: "#0b3243";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-80 {
  background-color: #08212d !important;
}
.schools-80::after {
  content: "#08212d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-90 {
  background-color: #041116 !important;
}
.schools-90::after {
  content: "#041116";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-100 {
  background-color: #000000 !important;
}
.schools-100::after {
  content: "#000000";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-0 {
  background-color: #26a7df !important;
}
.schools-lite-0::after {
  content: "#26a7df";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-10 {
  background-color: #3cb0e2 !important;
}
.schools-lite-10::after {
  content: "#3cb0e2";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-20 {
  background-color: #51b9e5 !important;
}
.schools-lite-20::after {
  content: "#51b9e5";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-30 {
  background-color: #67c1e9 !important;
}
.schools-lite-30::after {
  content: "#67c1e9";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-40 {
  background-color: #7dcaec !important;
}
.schools-lite-40::after {
  content: "#7dcaec";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-50 {
  background-color: #93d3ef !important;
}
.schools-lite-50::after {
  content: "#93d3ef";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-60 {
  background-color: #a8dcf2 !important;
}
.schools-lite-60::after {
  content: "#a8dcf2";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-70 {
  background-color: #bee5f5 !important;
}
.schools-lite-70::after {
  content: "#bee5f5";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-80 {
  background-color: #d4edf9 !important;
}
.schools-lite-80::after {
  content: "#d4edf9";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-90 {
  background-color: #e9f6fc !important;
}
.schools-lite-90::after {
  content: "#e9f6fc";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.schools-lite-100 {
  background-color: #ffffff !important;
}
.schools-lite-100::after {
  content: "#ffffff";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-0 {
  background-color: #003457 !important;
}
.primaryDarkBlue-0::after {
  content: "#003457";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-10 {
  background-color: #002f4e !important;
}
.primaryDarkBlue-10::after {
  content: "#002f4e";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-20 {
  background-color: #002a46 !important;
}
.primaryDarkBlue-20::after {
  content: "#002a46";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-30 {
  background-color: #00243d !important;
}
.primaryDarkBlue-30::after {
  content: "#00243d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-40 {
  background-color: #001f34 !important;
}
.primaryDarkBlue-40::after {
  content: "#001f34";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-50 {
  background-color: #001a2c !important;
}
.primaryDarkBlue-50::after {
  content: "#001a2c";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-60 {
  background-color: #001523 !important;
}
.primaryDarkBlue-60::after {
  content: "#001523";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-70 {
  background-color: #00101a !important;
}
.primaryDarkBlue-70::after {
  content: "#00101a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-80 {
  background-color: #000a11 !important;
}
.primaryDarkBlue-80::after {
  content: "#000a11";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-90 {
  background-color: #000509 !important;
}
.primaryDarkBlue-90::after {
  content: "#000509";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-100 {
  background-color: #000000 !important;
}
.primaryDarkBlue-100::after {
  content: "#000000";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-0 {
  background-color: #003457 !important;
}
.primaryDarkBlue-lite-0::after {
  content: "#003457";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-10 {
  background-color: #1a4868 !important;
}
.primaryDarkBlue-lite-10::after {
  content: "#1a4868";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-20 {
  background-color: #335d79 !important;
}
.primaryDarkBlue-lite-20::after {
  content: "#335d79";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-30 {
  background-color: #4d7189 !important;
}
.primaryDarkBlue-lite-30::after {
  content: "#4d7189";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-40 {
  background-color: #66859a !important;
}
.primaryDarkBlue-lite-40::after {
  content: "#66859a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-50 {
  background-color: #809aab !important;
}
.primaryDarkBlue-lite-50::after {
  content: "#809aab";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-60 {
  background-color: #99aebc !important;
}
.primaryDarkBlue-lite-60::after {
  content: "#99aebc";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-70 {
  background-color: #b3c2cd !important;
}
.primaryDarkBlue-lite-70::after {
  content: "#b3c2cd";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-80 {
  background-color: #ccd6dd !important;
}
.primaryDarkBlue-lite-80::after {
  content: "#ccd6dd";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-90 {
  background-color: #ecebee !important;
}
.primaryDarkBlue-lite-90::after {
  content: "#ecebee";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.primaryDarkBlue-lite-100 {
  background-color: #ffffff !important;
}
.primaryDarkBlue-lite-100::after {
  content: "#ffffff";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-0 {
  background-color: #d42941 !important;
}
.alumni-0::after {
  content: "#d42941";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-10 {
  background-color: #bf253b !important;
}
.alumni-10::after {
  content: "#bf253b";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-20 {
  background-color: #aa2134 !important;
}
.alumni-20::after {
  content: "#aa2134";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-30 {
  background-color: #941d2e !important;
}
.alumni-30::after {
  content: "#941d2e";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-40 {
  background-color: #7f1927 !important;
}
.alumni-40::after {
  content: "#7f1927";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-50 {
  background-color: #6a1521 !important;
}
.alumni-50::after {
  content: "#6a1521";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-60 {
  background-color: #55101a !important;
}
.alumni-60::after {
  content: "#55101a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-70 {
  background-color: #400c13 !important;
}
.alumni-70::after {
  content: "#400c13";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-80 {
  background-color: #2a080d !important;
}
.alumni-80::after {
  content: "#2a080d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-90 {
  background-color: #150406 !important;
}
.alumni-90::after {
  content: "#150406";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-100 {
  background-color: #000000 !important;
}
.alumni-100::after {
  content: "#000000";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-0 {
  background-color: #d42941 !important;
}
.alumni-lite-0::after {
  content: "#d42941";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-10 {
  background-color: #d83e54 !important;
}
.alumni-lite-10::after {
  content: "#d83e54";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-20 {
  background-color: #dd5467 !important;
}
.alumni-lite-20::after {
  content: "#dd5467";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-30 {
  background-color: #e1697a !important;
}
.alumni-lite-30::after {
  content: "#e1697a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-40 {
  background-color: #e57f8d !important;
}
.alumni-lite-40::after {
  content: "#e57f8d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-50 {
  background-color: #ea94a0 !important;
}
.alumni-lite-50::after {
  content: "#ea94a0";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-60 {
  background-color: #eea9b3 !important;
}
.alumni-lite-60::after {
  content: "#eea9b3";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-70 {
  background-color: #f2bfc6 !important;
}
.alumni-lite-70::after {
  content: "#f2bfc6";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-80 {
  background-color: #f6d4d9 !important;
}
.alumni-lite-80::after {
  content: "#f6d4d9";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-90 {
  background-color: #fbeaec !important;
}
.alumni-lite-90::after {
  content: "#fbeaec";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.alumni-lite-100 {
  background-color: #ffffff !important;
}
.alumni-lite-100::after {
  content: "#ffffff";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-0 {
  background-color: #f05a2a !important;
}
.counsellors-0::after {
  content: "#f05a2a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-10 {
  background-color: #d85126 !important;
}
.counsellors-10::after {
  content: "#d85126";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-20 {
  background-color: #c04822 !important;
}
.counsellors-20::after {
  content: "#c04822";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-30 {
  background-color: #a83f1d !important;
}
.counsellors-30::after {
  content: "#a83f1d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-40 {
  background-color: #903619 !important;
}
.counsellors-40::after {
  content: "#903619";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-50 {
  background-color: #782d15 !important;
}
.counsellors-50::after {
  content: "#782d15";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-60 {
  background-color: #602411 !important;
}
.counsellors-60::after {
  content: "#602411";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-70 {
  background-color: #481b0d !important;
}
.counsellors-70::after {
  content: "#481b0d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-80 {
  background-color: #301208 !important;
}
.counsellors-80::after {
  content: "#301208";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-90 {
  background-color: #180904 !important;
}
.counsellors-90::after {
  content: "#180904";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-100 {
  background-color: #000000 !important;
}
.counsellors-100::after {
  content: "#000000";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-0 {
  background-color: #f05a2a !important;
}
.counsellors-lite-0::after {
  content: "#f05a2a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-10 {
  background-color: #f26b3f !important;
}
.counsellors-lite-10::after {
  content: "#f26b3f";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-20 {
  background-color: #f37b55 !important;
}
.counsellors-lite-20::after {
  content: "#f37b55";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-30 {
  background-color: #f58c6a !important;
}
.counsellors-lite-30::after {
  content: "#f58c6a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-40 {
  background-color: #f69c7f !important;
}
.counsellors-lite-40::after {
  content: "#f69c7f";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-50 {
  background-color: #f8ad95 !important;
}
.counsellors-lite-50::after {
  content: "#f8ad95";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-60 {
  background-color: #f9bdaa !important;
}
.counsellors-lite-60::after {
  content: "#f9bdaa";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-70 {
  background-color: #fbcebf !important;
}
.counsellors-lite-70::after {
  content: "#fbcebf";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-80 {
  background-color: #fcded4 !important;
}
.counsellors-lite-80::after {
  content: "#fcded4";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-90 {
  background-color: #feefea !important;
}
.counsellors-lite-90::after {
  content: "#feefea";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.counsellors-lite-100 {
  background-color: #ffffff !important;
}
.counsellors-lite-100::after {
  content: "#ffffff";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-0 {
  background-color: #f8b018 !important;
}
.students-0::after {
  content: "#f8b018";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-10 {
  background-color: #df9e16 !important;
}
.students-10::after {
  content: "#df9e16";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-20 {
  background-color: #c68d13 !important;
}
.students-20::after {
  content: "#c68d13";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-30 {
  background-color: #ae7b11 !important;
}
.students-30::after {
  content: "#ae7b11";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-40 {
  background-color: #956a0e !important;
}
.students-40::after {
  content: "#956a0e";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-50 {
  background-color: #7c580c !important;
}
.students-50::after {
  content: "#7c580c";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-60 {
  background-color: #63460a !important;
}
.students-60::after {
  content: "#63460a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-70 {
  background-color: #4a3507 !important;
}
.students-70::after {
  content: "#4a3507";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-80 {
  background-color: #322305 !important;
}
.students-80::after {
  content: "#322305";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-90 {
  background-color: #191202 !important;
}
.students-90::after {
  content: "#191202";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-100 {
  background-color: #000000 !important;
}
.students-100::after {
  content: "#000000";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-0 {
  background-color: #f8b018 !important;
}
.students-lite-0::after {
  content: "#f8b018";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-10 {
  background-color: #f9b82f !important;
}
.students-lite-10::after {
  content: "#f9b82f";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-20 {
  background-color: #f9c046 !important;
}
.students-lite-20::after {
  content: "#f9c046";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-30 {
  background-color: #fac85d !important;
}
.students-lite-30::after {
  content: "#fac85d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-40 {
  background-color: #fbd074 !important;
}
.students-lite-40::after {
  content: "#fbd074";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-50 {
  background-color: #fcd88c !important;
}
.students-lite-50::after {
  content: "#fcd88c";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-60 {
  background-color: #fcdfa3 !important;
}
.students-lite-60::after {
  content: "#fcdfa3";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-70 {
  background-color: #fde7ba !important;
}
.students-lite-70::after {
  content: "#fde7ba";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-80 {
  background-color: #feefd1 !important;
}
.students-lite-80::after {
  content: "#feefd1";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-90 {
  background-color: #fef7e8 !important;
}
.students-lite-90::after {
  content: "#fef7e8";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.students-lite-100 {
  background-color: #ffffff !important;
}
.students-lite-100::after {
  content: "#ffffff";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-0 {
  background-color: #f8b018 !important;
}
.parents-0::after {
  content: "#f8b018";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-10 {
  background-color: #df9e16 !important;
}
.parents-10::after {
  content: "#df9e16";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-20 {
  background-color: #c68d13 !important;
}
.parents-20::after {
  content: "#c68d13";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-30 {
  background-color: #ae7b11 !important;
}
.parents-30::after {
  content: "#ae7b11";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-40 {
  background-color: #956a0e !important;
}
.parents-40::after {
  content: "#956a0e";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-50 {
  background-color: #7c580c !important;
}
.parents-50::after {
  content: "#7c580c";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-60 {
  background-color: #63460a !important;
}
.parents-60::after {
  content: "#63460a";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-70 {
  background-color: #4a3507 !important;
}
.parents-70::after {
  content: "#4a3507";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-80 {
  background-color: #322305 !important;
}
.parents-80::after {
  content: "#322305";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-90 {
  background-color: #191202 !important;
}
.parents-90::after {
  content: "#191202";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-100 {
  background-color: #000000 !important;
}
.parents-100::after {
  content: "#000000";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-0 {
  background-color: #f8b018 !important;
}
.parents-lite-0::after {
  content: "#f8b018";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-10 {
  background-color: #f9b82f !important;
}
.parents-lite-10::after {
  content: "#f9b82f";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-20 {
  background-color: #f9c046 !important;
}
.parents-lite-20::after {
  content: "#f9c046";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-30 {
  background-color: #fac85d !important;
}
.parents-lite-30::after {
  content: "#fac85d";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-40 {
  background-color: #fbd074 !important;
}
.parents-lite-40::after {
  content: "#fbd074";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-50 {
  background-color: #fcd88c !important;
}
.parents-lite-50::after {
  content: "#fcd88c";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-60 {
  background-color: #fcdfa3 !important;
}
.parents-lite-60::after {
  content: "#fcdfa3";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-70 {
  background-color: #fde7ba !important;
}
.parents-lite-70::after {
  content: "#fde7ba";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-80 {
  background-color: #feefd1 !important;
}
.parents-lite-80::after {
  content: "#feefd1";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-90 {
  background-color: #fef7e8 !important;
}
.parents-lite-90::after {
  content: "#fef7e8";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

.parents-lite-100 {
  background-color: #ffffff !important;
}
.parents-lite-100::after {
  content: "#ffffff";
  position: relative;
  top: 30px;
  display: flex;
  justify-content: center;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: "Jost", sans-serif;
}

body {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.font-9 {
  font-size: 9px;
}
.font-10 {
  font-size: 10px;
}
.font-11 {
  font-size: 11px;
}
.font-12 {
  font-size: 12px;
}
.font-13 {
  font-size: 13px;
}
.font-14 {
  font-size: 14px;
}
.font-15 {
  font-size: 15px;
}
.font-16 {
  font-size: 16px;
}
.font-17 {
  font-size: 17px;
}
.font-18 {
  font-size: 18px;
}
.font-19 {
  font-size: 19px;
}
.font-20 {
  font-size: 20px;
  line-height: 22px;
}
.font-21 {
  font-size: 21px;
}
.font-22 {
  font-size: 22px;
}
.font-23 {
  font-size: 23px;
}
.font-24 {
  font-size: 24px;
}
.font-25 {
  font-size: 25px;
}
.font-26 {
  font-size: 26px;
}
.font-27 {
  font-size: 27px;
}
.font-28 {
  font-size: 28px;
}
.font-29 {
  font-size: 29px;
}
.font-30 {
  font-size: 30px;
}
.font-31 {
  font-size: 31px;
}
.font-32 {
  font-size: 32px;
}
.font-100 {
  font-weight: 100;
}
.font-300 {
  font-weight: 300;
}
.font-400 {
  font-weight: 400;
}
.font-500 {
  font-weight: 500;
}
.font-600 {
  font-weight: 600;
}
.font-700 {
  font-weight: 700;
}
.font-900 {
  font-weight: 900;
}

.text-dark-gray {
  color: #3A3A3A;
}

.flex-1 {
  flex: 1 1;
}

.w-140 {
  width: 140px;
}
.w-270 {
  max-width: 270px;
  width: 100%;
}
.w-312 {
  max-width: 312px;
  width: 100%;
}
.w-800 {
  max-width: 800px;
  width: 100%;
}
.w-860 {
  max-width: 860px;
  width: 100%;
}
.w-1030 {
  max-width: 1030px;
  width: 100%;
}

.height-46 {
  height: 46px;
}

.min-height-250 {
  min-height: 250px;
}

.bg-grd-blue {
  background: rgb(23, 76, 117);
  background: radial-gradient(circle, rgb(23, 76, 117) 0%, rgb(9, 50, 83) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#174c75",endColorstr="#093253",GradientType=1);
}

.btn-green {
  background: #5CAE48;
  border-radius: 25px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
}
.btn-green:hover {
  background: #f8b018;
}

.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #fff;
}
.wrapper .dark-section {
  flex: 1 1;
  background-color: rgb(11, 52, 84);
  background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/collage-building.svg);
  background-repeat: no-repeat;
  background-position: right top 30%;
  background-blend-mode: multiply;
}
@media (max-width: 575px) {
  .wrapper .dark-section {
    clip-path: polygon(50% 0%, 100% 0, 100% 93%, 50% 100%, 0 93%, 0 0);
  }
}
.wrapper .dark-section.student-img {
  background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/gradute.svg);
  background-position: bottom center;
  background-size: 800px;
}
@media (max-width: 575px) {
  .wrapper .dark-section.student-img {
    background-size: 450px;
  }
}
.wrapper .dark-section.bg-grd-blue {
  background: rgb(23, 76, 117);
  background: radial-gradient(circle, rgb(23, 76, 117) 0%, rgb(9, 50, 83) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#174c75",endColorstr="#093253",GradientType=1);
}
.wrapper .dark-section .logo {
  background: #fff;
  display: flex;
  border-radius: 0 0 10px 10px;
  -webkit-border-radius: 0 0 10px 10px;
  -moz-border-radius: 0 0 10px 10px;
  -ms-border-radius: 0 0 10px 10px;
  -o-border-radius: 0 0 10px 10px;
  align-items: end;
  justify-content: center;
  margin: 0 auto;
  padding: 15px 30px;
  max-width: 300px;
  max-height: 230px;
  min-width: 300px;
}
.wrapper .dark-section .logo img {
  height: 100%;
  width: auto;
  max-width: 100%;
}
.wrapper .dark-section .home-page-title {
  font-size: 40px;
  text-align: center;
}
@media (max-width: 1024px) {
  .wrapper .dark-section .home-page-title {
    font-size: 30px;
  }
}
@media (max-width: 767px) {
  .wrapper .dark-section .home-page-title {
    font-size: 23px;
  }
}
.wrapper .dark-section .sep {
  width: 285px;
  height: 2px;
  background: #fff;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  margin: 30px 0;
}
.wrapper .dark-section .sep.blue {
  height: 2px;
  background: #2B6B9F;
  margin: 15px 0 45px;
}
.wrapper .dark-section .school-name {
  font-size: 45px;
  line-height: 50px;
  text-align: center;
}
@media (max-width: 1024px) {
  .wrapper .dark-section .school-name {
    font-size: 50px;
    line-height: 60px;
  }
}
.wrapper .dark-section .sub-school-tag {
  font-size: 36px;
  text-align: center;
  line-height: 51px;
  font-weight: 500;
}
@media (max-width: 1024px) {
  .wrapper .dark-section .sub-school-tag {
    font-size: 30px;
    line-height: 34px;
  }
}
.wrapper .dark-section .header-icon {
  margin-bottom: 22px;
  display: flex;
  align-items: end;
  position: relative;
}
.wrapper .dark-section .header-icon::before {
  position: absolute;
  width: 50px;
  height: 50px;
  background: #022642;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  top: 0;
  right: -10px;
}
.wrapper .dark-section .list {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 30px;
}
@media (max-width: 575px) {
  .wrapper .dark-section .list {
    font-size: 20px;
    line-height: 30px;
    padding-top: 40px;
    padding-left: 40px;
    padding-bottom: 50px;
  }
}
.wrapper .dark-section .list li {
  position: relative;
  padding-left: 40px;
}
.wrapper .dark-section .list li::before {
  content: "";
  position: absolute;
  top: 9px;
  left: 0;
  background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/green-check.svg) no-repeat left top/100%;
  width: 24px;
  height: 24px;
}
@media (max-width: 575px) {
  .wrapper .dark-section .list li::before {
    width: 20px;
    height: 20px;
    top: 5px;
  }
}
.wrapper .dark-section .list li:not(:last-child) {
  margin-bottom: 30px;
}
.wrapper .dark-section .id-title {
  font-size: 30px;
  line-height: 45px;
  font-weight: 600;
}
.wrapper .dark-section .form-title {
  font-size: 32px;
  line-height: 40px;
  text-align: center;
  font-weight: 600;
  border: none;
  color: #fff;
}
@media (max-width: 575px) {
  .wrapper .dark-section .form-title {
    font-size: 20px;
    line-height: 26px;
    text-align: left;
    font-weight: 500;
  }
}
.wrapper .dark-section .form-label {
  color: #fff;
}
.wrapper .dark-section .white-label {
  background: white;
  width: 100%;
  height: 60px;
  border-radius: 35px;
  -webkit-border-radius: 35px;
  -moz-border-radius: 35px;
  -ms-border-radius: 35px;
  -o-border-radius: 35px;
  max-width: 200px;
  min-width: 200px;
  padding: 0 25px;
  color: black;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 18px;
  cursor: pointer;
}
.wrapper .dark-section .white-label i {
  width: 13px;
  height: 13px;
  border: 1px solid #666666;
  border-radius: 50%;
  margin-right: 10px;
}
.wrapper .dark-section .form-check-input:checked + .white-label i {
  border-color: #5CAE48;
  background-color: #5CAE48;
}
.wrapper .dark-section .btn-submit {
  width: 140px;
  background: #5CAE48;
  border-radius: 25px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
}
.wrapper .dark-section .btn-submit:hover {
  background: #f8b018;
}
.wrapper .footer-text-1 {
  font-size: 36px;
  line-height: 45px;
  font-weight: 600;
  text-align: center;
}
@media (max-width: 1024px) {
  .wrapper .footer-text-1 {
    font-size: 24px;
    line-height: 32px;
  }
}
.wrapper .footer-text-2 {
  font-size: 30px;
  text-align: center;
}
@media (max-width: 1024px) {
  .wrapper .footer-text-2 {
    font-size: 24px;
  }
}
.wrapper .principal-wrap {
  width: 281px;
  position: relative;
  margin: 0 auto;
}
.wrapper .principal-wrap .arrow-img {
  position: absolute;
  right: calc(100% + 10px);
  bottom: 10px;
}
.wrapper .principal-wrap .btn-green {
  width: 100%;
  background: #5CAE48;
  border-radius: 25px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
}
.wrapper .principal-wrap .btn-green:hover {
  background: #f8b018;
}
.wrapper .navigation_footer_wrap {
  position: sticky;
  bottom: 30px;
  height: 0;
}
@media (max-width: 1366px) {
  .wrapper .navigation_footer_wrap:not(.homePageLink) {
    bottom: 80px;
  }
}
@media (min-width: 768px) {
  .wrapper .navigation_footer_wrap:not(.homePageLink) {
    bottom: 80px;
  }
}
@media (max-width: 575px) {
  .wrapper .navigation_footer_wrap {
    height: 50px;
  }
}
.wrapper .navigation_footer_wrap .navigation_footer {
  position: absolute;
  left: 0;
  right: 0;
  width: calc(100% - 80px);
  height: 55px;
  margin: auto;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  max-width: 250px;
  background: #fff;
  border-radius: 25px;
  -webkit-border-radius: 25px;
  -moz-border-radius: 25px;
  -ms-border-radius: 25px;
  -o-border-radius: 25px;
  align-items: center;
  padding: 0 5px;
  box-shadow: 0 0px 10px 1px rgba(118, 118, 118, 0.1803921569);
}
.wrapper .navigation_footer_wrap .navigation_footer a {
  width: auto;
  height: 45px;
  display: flex;
  border-radius: 25px;
  -webkit-border-radius: 25px;
  -moz-border-radius: 25px;
  -ms-border-radius: 25px;
  -o-border-radius: 25px;
  align-items: center;
  padding: 0 20px;
  background-color: #5CAE48;
  color: #ffffff;
  text-decoration: none;
  transition: all 0.3s ease-in-out;
}
.wrapper .navigation_footer_wrap .navigation_footer a.btn-back i {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px 12px;
  width: 10px;
  height: 20px;
  margin-right: 7px;
}
.wrapper .navigation_footer_wrap .navigation_footer a.btn-next i {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px 12px;
  width: 10px;
  height: 20px;
  margin-left: 7px;
}
.wrapper .navigation_footer_wrap .navigation_footer a:hover {
  background-color: #35911f;
  text-decoration: none;
}
.wrapper .navigation_footer_wrap .navigation_footer a span {
  text-decoration: none;
}

.left-graph {
  position: absolute;
  left: 0;
  top: -40%;
  width: 50%;
}
@media (max-width: 1500px) {
  .left-graph {
    top: -30%;
  }
}
@media (max-width: 1250px) {
  .left-graph {
    top: -20%;
  }
}
@media (max-width: 1100px) {
  .left-graph {
    top: -10%;
  }
}
@media (max-width: 575px) {
  .left-graph {
    top: 0%;
  }
}
.left-graph img {
  width: 100%;
}

.right-graph {
  position: absolute;
  right: 0;
  top: -71%;
  width: 50%;
}
@media (max-width: 1500px) {
  .right-graph {
    top: -50%;
  }
}
@media (max-width: 1250px) {
  .right-graph {
    top: -40%;
  }
}
@media (max-width: 1100px) {
  .right-graph {
    top: -30%;
  }
}
@media (max-width: 575px) {
  .right-graph {
    top: -9%;
    width: 70%;
  }
}
.right-graph img {
  width: 100%;
}

.thanksTxt {
  font-size: 100px;
  font-weight: 700;
  margin: 30px 0;
  font-style: italic;
}
@media (max-width: 1100px) {
  .thanksTxt {
    font-size: 60px;
    margin: 20px 0;
  }
}
.thanksTxt-sub {
  font-size: 36px;
  font-weight: 600;
  text-align: center;
}
@media (max-width: 575px) {
  .thanksTxt-sub {
    font-size: 24px;
  }
}
.thanksTxt-sub-2 {
  font-size: 46px;
  font-weight: 600;
  text-align: center;
}
@media (max-width: 575px) {
  .thanksTxt-sub-2 {
    font-size: 30px;
  }
}

@media (max-width: 1100px) {
  .thumb img {
    max-width: 130px;
  }
}
.form-label {
  display: inline-block;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.form-control {
  width: 100%;
  padding: 0.5rem;
  box-sizing: border-box;
}

.error-message {
  color: red;
  font-size: 0.875rem;
  margin-top: -0.25rem; /* Prevent the error message from adding extra space */
  margin-bottom: 0.5rem;
  position: absolute; /* Position the error message absolutely */
}

.form-group {
  position: relative; /* Necessary to position the error message within the form group */
  margin-bottom: 1.5rem; /* Add space between form groups */
}

input.error {
  border-color: red;
}`, "",{"version":3,"sources":["webpack://./src/styles/css_pre_singup/variable.scss","webpack://./src/styles/css_pre_singup/style.css","webpack://./src/styles/css_pre_singup/style.scss","webpack://./src/styles/css_pre_singup/mixins.scss"],"names":[],"mappings":"AAAA,iBAAA;AAWA,gBAAA;AAgZM;EACE,oCAAA;ACvZR;ADwZQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACtZV;;AD+YM;EACE,oCAAA;AC5YR;AD6YQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC3YV;;ADoYM;EACE,oCAAA;ACjYR;ADkYQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AChYV;;ADyXM;EACE,oCAAA;ACtXR;ADuXQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACrXV;;AD8WM;EACE,oCAAA;AC3WR;AD4WQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC1WV;;ADmWM;EACE,oCAAA;AChWR;ADiWQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC/VV;;ADwVM;EACE,oCAAA;ACrVR;ADsVQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACpVV;;AD6UM;EACE,oCAAA;AC1UR;AD2UQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACzUV;;ADkUM;EACE,oCAAA;AC/TR;ADgUQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC9TV;;ADuTM;EACE,oCAAA;ACpTR;ADqTQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACnTV;;AD4SM;EACE,oCAAA;ACzSR;AD0SQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACxSV;;ADiSM;EACE,oCAAA;AC9RR;AD+RQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC7RV;;ADsRM;EACE,oCAAA;ACnRR;ADoRQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AClRV;;AD2QM;EACE,oCAAA;ACxQR;ADyQQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACvQV;;ADgQM;EACE,oCAAA;AC7PR;AD8PQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC5PV;;ADqPM;EACE,oCAAA;AClPR;ADmPQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACjPV;;AD0OM;EACE,oCAAA;ACvOR;ADwOQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACtOV;;AD+NM;EACE,oCAAA;AC5NR;AD6NQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC3NV;;ADoNM;EACE,oCAAA;ACjNR;ADkNQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AChNV;;ADyMM;EACE,oCAAA;ACtMR;ADuMQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACrMV;;AD8LM;EACE,oCAAA;AC3LR;AD4LQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC1LV;;ADmLM;EACE,oCAAA;AChLR;ADiLQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC/KV;;ADwKM;EACE,oCAAA;ACrKR;ADsKQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACpKV;;AD6JM;EACE,oCAAA;AC1JR;AD2JQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACzJV;;ADkJM;EACE,oCAAA;AC/IR;ADgJQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC9IV;;ADuIM;EACE,oCAAA;ACpIR;ADqIQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACnIV;;AD4HM;EACE,oCAAA;ACzHR;AD0HQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACxHV;;ADiHM;EACE,oCAAA;AC9GR;AD+GQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC7GV;;ADsGM;EACE,oCAAA;ACnGR;ADoGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AClGV;;AD2FM;EACE,oCAAA;ACxFR;ADyFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACvFV;;ADgFM;EACE,oCAAA;AC7ER;AD8EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC5EV;;ADqEM;EACE,oCAAA;AClER;ADmEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACjEV;;AD0DM;EACE,oCAAA;ACvDR;ADwDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACtDV;;AD+CM;EACE,oCAAA;AC5CR;AD6CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC3CV;;ADoCM;EACE,oCAAA;ACjCR;ADkCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AChCV;;ADyBM;EACE,oCAAA;ACtBR;ADuBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACrBV;;ADcM;EACE,oCAAA;ACXR;ADYQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACVV;;ADGM;EACE,oCAAA;ACAR;ADCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACCV;;ADRM;EACE,oCAAA;ACWR;ADVQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACYV;;ADnBM;EACE,oCAAA;ACsBR;ADrBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACuBV;;AD9BM;EACE,oCAAA;ACiCR;ADhCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACkCV;;ADzCM;EACE,oCAAA;AC4CR;AD3CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC6CV;;ADpDM;EACE,oCAAA;ACuDR;ADtDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACwDV;;AD/DM;EACE,oCAAA;ACkER;ADjEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACmEV;;AD1EM;EACE,oCAAA;AC6ER;AD5EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC8EV;;ADrFM;EACE,oCAAA;ACwFR;ADvFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACyFV;;ADhGM;EACE,oCAAA;ACmGR;ADlGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACoGV;;AD3GM;EACE,oCAAA;AC8GR;AD7GQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+GV;;ADtHM;EACE,oCAAA;ACyHR;ADxHQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC0HV;;ADjIM;EACE,oCAAA;ACoIR;ADnIQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACqIV;;AD5IM;EACE,oCAAA;AC+IR;AD9IQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACgJV;;ADvJM;EACE,oCAAA;AC0JR;ADzJQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC2JV;;ADlKM;EACE,oCAAA;ACqKR;ADpKQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACsKV;;AD7KM;EACE,oCAAA;ACgLR;AD/KQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACiLV;;ADxLM;EACE,oCAAA;AC2LR;AD1LQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC4LV;;ADnMM;EACE,oCAAA;ACsMR;ADrMQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACuMV;;AD9MM;EACE,oCAAA;ACiNR;ADhNQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACkNV;;ADzNM;EACE,oCAAA;AC4NR;AD3NQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC6NV;;ADpOM;EACE,oCAAA;ACuOR;ADtOQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACwOV;;AD/OM;EACE,oCAAA;ACkPR;ADjPQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACmPV;;AD1PM;EACE,oCAAA;AC6PR;AD5PQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC8PV;;ADrQM;EACE,oCAAA;ACwQR;ADvQQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACyQV;;ADhRM;EACE,oCAAA;ACmRR;ADlRQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACoRV;;AD3RM;EACE,oCAAA;AC8RR;AD7RQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+RV;;ADtSM;EACE,oCAAA;ACySR;ADxSQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC0SV;;ADjTM;EACE,oCAAA;ACoTR;ADnTQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACqTV;;AD5TM;EACE,oCAAA;AC+TR;AD9TQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACgUV;;ADvUM;EACE,oCAAA;AC0UR;ADzUQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC2UV;;ADlVM;EACE,oCAAA;ACqVR;ADpVQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACsVV;;AD7VM;EACE,oCAAA;ACgWR;AD/VQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACiWV;;ADxWM;EACE,oCAAA;AC2WR;AD1WQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC4WV;;ADnXM;EACE,oCAAA;ACsXR;ADrXQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACuXV;;AD9XM;EACE,oCAAA;ACiYR;ADhYQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACkYV;;ADzYM;EACE,oCAAA;AC4YR;AD3YQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC6YV;;ADpZM;EACE,oCAAA;ACuZR;ADtZQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACwZV;;AD/ZM;EACE,oCAAA;ACkaR;ADjaQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACmaV;;AD1aM;EACE,oCAAA;AC6aR;AD5aQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC8aV;;ADrbM;EACE,oCAAA;ACwbR;ADvbQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACybV;;ADhcM;EACE,oCAAA;ACmcR;ADlcQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACocV;;AD3cM;EACE,oCAAA;AC8cR;AD7cQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+cV;;ADtdM;EACE,oCAAA;ACydR;ADxdQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC0dV;;ADjeM;EACE,oCAAA;ACoeR;ADneQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACqeV;;AD5eM;EACE,oCAAA;AC+eR;AD9eQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACgfV;;ADvfM;EACE,oCAAA;AC0fR;ADzfQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC2fV;;ADlgBM;EACE,oCAAA;ACqgBR;ADpgBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACsgBV;;AD7gBM;EACE,oCAAA;ACghBR;AD/gBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACihBV;;ADxhBM;EACE,oCAAA;AC2hBR;AD1hBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC4hBV;;ADniBM;EACE,oCAAA;ACsiBR;ADriBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACuiBV;;AD9iBM;EACE,oCAAA;ACijBR;ADhjBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACkjBV;;ADzjBM;EACE,oCAAA;AC4jBR;AD3jBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC6jBV;;ADpkBM;EACE,oCAAA;ACukBR;ADtkBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACwkBV;;AD/kBM;EACE,oCAAA;ACklBR;ADjlBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACmlBV;;AD1lBM;EACE,oCAAA;AC6lBR;AD5lBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC8lBV;;ADrmBM;EACE,oCAAA;ACwmBR;ADvmBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACymBV;;ADhnBM;EACE,oCAAA;ACmnBR;ADlnBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AConBV;;AD3nBM;EACE,oCAAA;AC8nBR;AD7nBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+nBV;;ADtoBM;EACE,oCAAA;ACyoBR;ADxoBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC0oBV;;ADjpBM;EACE,oCAAA;ACopBR;ADnpBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACqpBV;;AD5pBM;EACE,oCAAA;AC+pBR;AD9pBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACgqBV;;ADvqBM;EACE,oCAAA;AC0qBR;ADzqBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC2qBV;;ADlrBM;EACE,oCAAA;ACqrBR;ADprBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACsrBV;;AD7rBM;EACE,oCAAA;ACgsBR;AD/rBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACisBV;;ADxsBM;EACE,oCAAA;AC2sBR;AD1sBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC4sBV;;ADntBM;EACE,oCAAA;ACstBR;ADrtBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACutBV;;AD9tBM;EACE,oCAAA;ACiuBR;ADhuBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACkuBV;;ADzuBM;EACE,oCAAA;AC4uBR;AD3uBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC6uBV;;ADpvBM;EACE,oCAAA;ACuvBR;ADtvBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACwvBV;;AD/vBM;EACE,oCAAA;ACkwBR;ADjwBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACmwBV;;AD1wBM;EACE,oCAAA;AC6wBR;AD5wBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC8wBV;;ADrxBM;EACE,oCAAA;ACwxBR;ADvxBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACyxBV;;ADhyBM;EACE,oCAAA;ACmyBR;ADlyBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACoyBV;;AD3yBM;EACE,oCAAA;AC8yBR;AD7yBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+yBV;;ADtzBM;EACE,oCAAA;ACyzBR;ADxzBQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC0zBV;;ADj0BM;EACE,oCAAA;ACo0BR;ADn0BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACq0BV;;AD50BM;EACE,oCAAA;AC+0BR;AD90BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACg1BV;;ADv1BM;EACE,oCAAA;AC01BR;ADz1BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC21BV;;ADl2BM;EACE,oCAAA;ACq2BR;ADp2BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACs2BV;;AD72BM;EACE,oCAAA;ACg3BR;AD/2BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACi3BV;;ADx3BM;EACE,oCAAA;AC23BR;AD13BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC43BV;;ADn4BM;EACE,oCAAA;ACs4BR;ADr4BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACu4BV;;AD94BM;EACE,oCAAA;ACi5BR;ADh5BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACk5BV;;ADz5BM;EACE,oCAAA;AC45BR;AD35BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC65BV;;ADp6BM;EACE,oCAAA;ACu6BR;ADt6BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACw6BV;;AD/6BM;EACE,oCAAA;ACk7BR;ADj7BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACm7BV;;AD17BM;EACE,oCAAA;AC67BR;AD57BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC87BV;;ADr8BM;EACE,oCAAA;ACw8BR;ADv8BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACy8BV;;ADh9BM;EACE,oCAAA;ACm9BR;ADl9BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACo9BV;;AD39BM;EACE,oCAAA;AC89BR;AD79BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+9BV;;ADt+BM;EACE,oCAAA;ACy+BR;ADx+BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC0+BV;;ADj/BM;EACE,oCAAA;ACo/BR;ADn/BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACq/BV;;AD5/BM;EACE,oCAAA;AC+/BR;AD9/BQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACggCV;;ADvgCM;EACE,oCAAA;AC0gCR;ADzgCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC2gCV;;ADlhCM;EACE,oCAAA;ACqhCR;ADphCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACshCV;;AD7hCM;EACE,oCAAA;ACgiCR;AD/hCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACiiCV;;ADxiCM;EACE,oCAAA;AC2iCR;AD1iCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC4iCV;;ADnjCM;EACE,oCAAA;ACsjCR;ADrjCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACujCV;;AD9jCM;EACE,oCAAA;ACikCR;ADhkCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACkkCV;;ADzkCM;EACE,oCAAA;AC4kCR;AD3kCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC6kCV;;ADplCM;EACE,oCAAA;ACulCR;ADtlCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACwlCV;;AD/lCM;EACE,oCAAA;ACkmCR;ADjmCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACmmCV;;AD1mCM;EACE,oCAAA;AC6mCR;AD5mCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC8mCV;;ADrnCM;EACE,oCAAA;ACwnCR;ADvnCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACynCV;;ADhoCM;EACE,oCAAA;ACmoCR;ADloCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACooCV;;AD3oCM;EACE,oCAAA;AC8oCR;AD7oCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+oCV;;ADtpCM;EACE,oCAAA;ACypCR;ADxpCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC0pCV;;ADjqCM;EACE,oCAAA;ACoqCR;ADnqCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACqqCV;;AD5qCM;EACE,oCAAA;AC+qCR;AD9qCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACgrCV;;ADvrCM;EACE,oCAAA;AC0rCR;ADzrCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC2rCV;;ADlsCM;EACE,oCAAA;ACqsCR;ADpsCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACssCV;;AD7sCM;EACE,oCAAA;ACgtCR;AD/sCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACitCV;;ADxtCM;EACE,oCAAA;AC2tCR;AD1tCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC4tCV;;ADnuCM;EACE,oCAAA;ACsuCR;ADruCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACuuCV;;AD9uCM;EACE,oCAAA;ACivCR;ADhvCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACkvCV;;ADzvCM;EACE,oCAAA;AC4vCR;AD3vCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC6vCV;;ADpwCM;EACE,oCAAA;ACuwCR;ADtwCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACwwCV;;AD/wCM;EACE,oCAAA;ACkxCR;ADjxCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACmxCV;;AD1xCM;EACE,oCAAA;AC6xCR;AD5xCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC8xCV;;ADryCM;EACE,oCAAA;ACwyCR;ADvyCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACyyCV;;ADhzCM;EACE,oCAAA;ACmzCR;ADlzCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACozCV;;AD3zCM;EACE,oCAAA;AC8zCR;AD7zCQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+zCV;;ADt0CM;EACE,oCAAA;ACy0CR;ADx0CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC00CV;;ADj1CM;EACE,oCAAA;ACo1CR;ADn1CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACq1CV;;AD51CM;EACE,oCAAA;AC+1CR;AD91CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACg2CV;;ADv2CM;EACE,oCAAA;AC02CR;ADz2CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC22CV;;ADl3CM;EACE,oCAAA;ACq3CR;ADp3CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACs3CV;;AD73CM;EACE,oCAAA;ACg4CR;AD/3CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACi4CV;;ADx4CM;EACE,oCAAA;AC24CR;AD14CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC44CV;;ADn5CM;EACE,oCAAA;ACs5CR;ADr5CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACu5CV;;AD95CM;EACE,oCAAA;ACi6CR;ADh6CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACk6CV;;ADz6CM;EACE,oCAAA;AC46CR;AD36CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC66CV;;ADp7CM;EACE,oCAAA;ACu7CR;ADt7CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACw7CV;;AD/7CM;EACE,oCAAA;ACk8CR;ADj8CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACm8CV;;AD18CM;EACE,oCAAA;AC68CR;AD58CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC88CV;;ADr9CM;EACE,oCAAA;ACw9CR;ADv9CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACy9CV;;ADh+CM;EACE,oCAAA;ACm+CR;ADl+CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACo+CV;;AD3+CM;EACE,oCAAA;AC8+CR;AD7+CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC++CV;;ADj5DA,iBAAA;AAWA,gBAAA;AAgZM;EACE,oCAAA;AC2/CR;AD1/CQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC4/CV;;ADngDM;EACE,oCAAA;ACsgDR;ADrgDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACugDV;;AD9gDM;EACE,oCAAA;ACihDR;ADhhDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACkhDV;;ADzhDM;EACE,oCAAA;AC4hDR;AD3hDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC6hDV;;ADpiDM;EACE,oCAAA;ACuiDR;ADtiDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACwiDV;;AD/iDM;EACE,oCAAA;ACkjDR;ADjjDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACmjDV;;AD1jDM;EACE,oCAAA;AC6jDR;AD5jDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC8jDV;;ADrkDM;EACE,oCAAA;ACwkDR;ADvkDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACykDV;;ADhlDM;EACE,oCAAA;ACmlDR;ADllDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AColDV;;AD3lDM;EACE,oCAAA;AC8lDR;AD7lDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+lDV;;ADtmDM;EACE,oCAAA;ACymDR;ADxmDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC0mDV;;ADjnDM;EACE,oCAAA;AConDR;ADnnDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACqnDV;;AD5nDM;EACE,oCAAA;AC+nDR;AD9nDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACgoDV;;ADvoDM;EACE,oCAAA;AC0oDR;ADzoDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC2oDV;;ADlpDM;EACE,oCAAA;ACqpDR;ADppDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACspDV;;AD7pDM;EACE,oCAAA;ACgqDR;AD/pDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACiqDV;;ADxqDM;EACE,oCAAA;AC2qDR;AD1qDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC4qDV;;ADnrDM;EACE,oCAAA;ACsrDR;ADrrDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACurDV;;AD9rDM;EACE,oCAAA;ACisDR;ADhsDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACksDV;;ADzsDM;EACE,oCAAA;AC4sDR;AD3sDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC6sDV;;ADptDM;EACE,oCAAA;ACutDR;ADttDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACwtDV;;AD/tDM;EACE,oCAAA;ACkuDR;ADjuDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACmuDV;;AD1uDM;EACE,oCAAA;AC6uDR;AD5uDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC8uDV;;ADrvDM;EACE,oCAAA;ACwvDR;ADvvDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACyvDV;;ADhwDM;EACE,oCAAA;ACmwDR;ADlwDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACowDV;;AD3wDM;EACE,oCAAA;AC8wDR;AD7wDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+wDV;;ADtxDM;EACE,oCAAA;ACyxDR;ADxxDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC0xDV;;ADjyDM;EACE,oCAAA;ACoyDR;ADnyDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACqyDV;;AD5yDM;EACE,oCAAA;AC+yDR;AD9yDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACgzDV;;ADvzDM;EACE,oCAAA;AC0zDR;ADzzDQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC2zDV;;ADl0DM;EACE,oCAAA;ACq0DR;ADp0DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACs0DV;;AD70DM;EACE,oCAAA;ACg1DR;AD/0DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACi1DV;;ADx1DM;EACE,oCAAA;AC21DR;AD11DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC41DV;;ADn2DM;EACE,oCAAA;ACs2DR;ADr2DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACu2DV;;AD92DM;EACE,oCAAA;ACi3DR;ADh3DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACk3DV;;ADz3DM;EACE,oCAAA;AC43DR;AD33DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC63DV;;ADp4DM;EACE,oCAAA;ACu4DR;ADt4DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACw4DV;;AD/4DM;EACE,oCAAA;ACk5DR;ADj5DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACm5DV;;AD15DM;EACE,oCAAA;AC65DR;AD55DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC85DV;;ADr6DM;EACE,oCAAA;ACw6DR;ADv6DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACy6DV;;ADh7DM;EACE,oCAAA;ACm7DR;ADl7DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACo7DV;;AD37DM;EACE,oCAAA;AC87DR;AD77DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+7DV;;ADt8DM;EACE,oCAAA;ACy8DR;ADx8DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC08DV;;ADj9DM;EACE,oCAAA;ACo9DR;ADn9DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACq9DV;;AD59DM;EACE,oCAAA;AC+9DR;AD99DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACg+DV;;ADv+DM;EACE,oCAAA;AC0+DR;ADz+DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC2+DV;;ADl/DM;EACE,oCAAA;ACq/DR;ADp/DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACs/DV;;AD7/DM;EACE,oCAAA;ACggER;AD//DQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACigEV;;ADxgEM;EACE,oCAAA;AC2gER;AD1gEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC4gEV;;ADnhEM;EACE,oCAAA;ACshER;ADrhEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACuhEV;;AD9hEM;EACE,oCAAA;ACiiER;ADhiEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACkiEV;;ADziEM;EACE,oCAAA;AC4iER;AD3iEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC6iEV;;ADpjEM;EACE,oCAAA;ACujER;ADtjEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACwjEV;;AD/jEM;EACE,oCAAA;ACkkER;ADjkEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACmkEV;;AD1kEM;EACE,oCAAA;AC6kER;AD5kEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC8kEV;;ADrlEM;EACE,oCAAA;ACwlER;ADvlEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACylEV;;ADhmEM;EACE,oCAAA;ACmmER;ADlmEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AComEV;;AD3mEM;EACE,oCAAA;AC8mER;AD7mEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+mEV;;ADtnEM;EACE,oCAAA;ACynER;ADxnEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC0nEV;;ADjoEM;EACE,oCAAA;ACooER;ADnoEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACqoEV;;AD5oEM;EACE,oCAAA;AC+oER;AD9oEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACgpEV;;ADvpEM;EACE,oCAAA;AC0pER;ADzpEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC2pEV;;ADlqEM;EACE,oCAAA;ACqqER;ADpqEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACsqEV;;AD7qEM;EACE,oCAAA;ACgrER;AD/qEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACirEV;;ADxrEM;EACE,oCAAA;AC2rER;AD1rEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC4rEV;;ADnsEM;EACE,oCAAA;ACssER;ADrsEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACusEV;;AD9sEM;EACE,oCAAA;ACitER;ADhtEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACktEV;;ADztEM;EACE,oCAAA;AC4tER;AD3tEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC6tEV;;ADpuEM;EACE,oCAAA;ACuuER;ADtuEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACwuEV;;AD/uEM;EACE,oCAAA;ACkvER;ADjvEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACmvEV;;AD1vEM;EACE,oCAAA;AC6vER;AD5vEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC8vEV;;ADrwEM;EACE,oCAAA;ACwwER;ADvwEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACywEV;;ADhxEM;EACE,oCAAA;ACmxER;ADlxEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACoxEV;;AD3xEM;EACE,oCAAA;AC8xER;AD7xEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+xEV;;ADtyEM;EACE,oCAAA;ACyyER;ADxyEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC0yEV;;ADjzEM;EACE,oCAAA;ACozER;ADnzEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACqzEV;;AD5zEM;EACE,oCAAA;AC+zER;AD9zEQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACg0EV;;ADv0EM;EACE,oCAAA;AC00ER;ADz0EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC20EV;;ADl1EM;EACE,oCAAA;ACq1ER;ADp1EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACs1EV;;AD71EM;EACE,oCAAA;ACg2ER;AD/1EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACi2EV;;ADx2EM;EACE,oCAAA;AC22ER;AD12EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC42EV;;ADn3EM;EACE,oCAAA;ACs3ER;ADr3EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACu3EV;;AD93EM;EACE,oCAAA;ACi4ER;ADh4EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACk4EV;;ADz4EM;EACE,oCAAA;AC44ER;AD34EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC64EV;;ADp5EM;EACE,oCAAA;ACu5ER;ADt5EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACw5EV;;AD/5EM;EACE,oCAAA;ACk6ER;ADj6EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACm6EV;;AD16EM;EACE,oCAAA;AC66ER;AD56EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC86EV;;ADr7EM;EACE,oCAAA;ACw7ER;ADv7EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACy7EV;;ADh8EM;EACE,oCAAA;ACm8ER;ADl8EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACo8EV;;AD38EM;EACE,oCAAA;AC88ER;AD78EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+8EV;;ADt9EM;EACE,oCAAA;ACy9ER;ADx9EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC09EV;;ADj+EM;EACE,oCAAA;ACo+ER;ADn+EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACq+EV;;AD5+EM;EACE,oCAAA;AC++ER;AD9+EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACg/EV;;ADv/EM;EACE,oCAAA;AC0/ER;ADz/EQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC2/EV;;ADlgFM;EACE,oCAAA;ACqgFR;ADpgFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACsgFV;;AD7gFM;EACE,oCAAA;ACghFR;AD/gFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACihFV;;ADxhFM;EACE,oCAAA;AC2hFR;AD1hFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC4hFV;;ADniFM;EACE,oCAAA;ACsiFR;ADriFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACuiFV;;AD9iFM;EACE,oCAAA;ACijFR;ADhjFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACkjFV;;ADzjFM;EACE,oCAAA;AC4jFR;AD3jFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC6jFV;;ADpkFM;EACE,oCAAA;ACukFR;ADtkFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACwkFV;;AD/kFM;EACE,oCAAA;ACklFR;ADjlFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACmlFV;;AD1lFM;EACE,oCAAA;AC6lFR;AD5lFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC8lFV;;ADrmFM;EACE,oCAAA;ACwmFR;ADvmFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACymFV;;ADhnFM;EACE,oCAAA;ACmnFR;ADlnFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AConFV;;AD3nFM;EACE,oCAAA;AC8nFR;AD7nFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+nFV;;ADtoFM;EACE,oCAAA;ACyoFR;ADxoFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC0oFV;;ADjpFM;EACE,oCAAA;ACopFR;ADnpFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACqpFV;;AD5pFM;EACE,oCAAA;AC+pFR;AD9pFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACgqFV;;ADvqFM;EACE,oCAAA;AC0qFR;ADzqFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC2qFV;;ADlrFM;EACE,oCAAA;ACqrFR;ADprFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACsrFV;;AD7rFM;EACE,oCAAA;ACgsFR;AD/rFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACisFV;;ADxsFM;EACE,oCAAA;AC2sFR;AD1sFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC4sFV;;ADntFM;EACE,oCAAA;ACstFR;ADrtFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACutFV;;AD9tFM;EACE,oCAAA;ACiuFR;ADhuFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACkuFV;;ADzuFM;EACE,oCAAA;AC4uFR;AD3uFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC6uFV;;ADpvFM;EACE,oCAAA;ACuvFR;ADtvFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACwvFV;;AD/vFM;EACE,oCAAA;ACkwFR;ADjwFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACmwFV;;AD1wFM;EACE,oCAAA;AC6wFR;AD5wFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC8wFV;;ADrxFM;EACE,oCAAA;ACwxFR;ADvxFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACyxFV;;ADhyFM;EACE,oCAAA;ACmyFR;ADlyFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACoyFV;;AD3yFM;EACE,oCAAA;AC8yFR;AD7yFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+yFV;;ADtzFM;EACE,oCAAA;ACyzFR;ADxzFQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC0zFV;;ADj0FM;EACE,oCAAA;ACo0FR;ADn0FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACq0FV;;AD50FM;EACE,oCAAA;AC+0FR;AD90FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACg1FV;;ADv1FM;EACE,oCAAA;AC01FR;ADz1FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC21FV;;ADl2FM;EACE,oCAAA;ACq2FR;ADp2FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACs2FV;;AD72FM;EACE,oCAAA;ACg3FR;AD/2FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACi3FV;;ADx3FM;EACE,oCAAA;AC23FR;AD13FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC43FV;;ADn4FM;EACE,oCAAA;ACs4FR;ADr4FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACu4FV;;AD94FM;EACE,oCAAA;ACi5FR;ADh5FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACk5FV;;ADz5FM;EACE,oCAAA;AC45FR;AD35FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC65FV;;ADp6FM;EACE,oCAAA;ACu6FR;ADt6FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACw6FV;;AD/6FM;EACE,oCAAA;ACk7FR;ADj7FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACm7FV;;AD17FM;EACE,oCAAA;AC67FR;AD57FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC87FV;;ADr8FM;EACE,oCAAA;ACw8FR;ADv8FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACy8FV;;ADh9FM;EACE,oCAAA;ACm9FR;ADl9FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACo9FV;;AD39FM;EACE,oCAAA;AC89FR;AD79FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+9FV;;ADt+FM;EACE,oCAAA;ACy+FR;ADx+FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC0+FV;;ADj/FM;EACE,oCAAA;ACo/FR;ADn/FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACq/FV;;AD5/FM;EACE,oCAAA;AC+/FR;AD9/FQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACggGV;;ADvgGM;EACE,oCAAA;AC0gGR;ADzgGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC2gGV;;ADlhGM;EACE,oCAAA;ACqhGR;ADphGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACshGV;;AD7hGM;EACE,oCAAA;ACgiGR;AD/hGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACiiGV;;ADxiGM;EACE,oCAAA;AC2iGR;AD1iGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC4iGV;;ADnjGM;EACE,oCAAA;ACsjGR;ADrjGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACujGV;;AD9jGM;EACE,oCAAA;ACikGR;ADhkGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACkkGV;;ADzkGM;EACE,oCAAA;AC4kGR;AD3kGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC6kGV;;ADplGM;EACE,oCAAA;ACulGR;ADtlGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACwlGV;;AD/lGM;EACE,oCAAA;ACkmGR;ADjmGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACmmGV;;AD1mGM;EACE,oCAAA;AC6mGR;AD5mGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC8mGV;;ADrnGM;EACE,oCAAA;ACwnGR;ADvnGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACynGV;;ADhoGM;EACE,oCAAA;ACmoGR;ADloGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACooGV;;AD3oGM;EACE,oCAAA;AC8oGR;AD7oGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+oGV;;ADtpGM;EACE,oCAAA;ACypGR;ADxpGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC0pGV;;ADjqGM;EACE,oCAAA;ACoqGR;ADnqGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACqqGV;;AD5qGM;EACE,oCAAA;AC+qGR;AD9qGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACgrGV;;ADvrGM;EACE,oCAAA;AC0rGR;ADzrGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC2rGV;;ADlsGM;EACE,oCAAA;ACqsGR;ADpsGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACssGV;;AD7sGM;EACE,oCAAA;ACgtGR;AD/sGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACitGV;;ADxtGM;EACE,oCAAA;AC2tGR;AD1tGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC4tGV;;ADnuGM;EACE,oCAAA;ACsuGR;ADruGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACuuGV;;AD9uGM;EACE,oCAAA;ACivGR;ADhvGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACkvGV;;ADzvGM;EACE,oCAAA;AC4vGR;AD3vGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC6vGV;;ADpwGM;EACE,oCAAA;ACuwGR;ADtwGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACwwGV;;AD/wGM;EACE,oCAAA;ACkxGR;ADjxGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACmxGV;;AD1xGM;EACE,oCAAA;AC6xGR;AD5xGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC8xGV;;ADryGM;EACE,oCAAA;ACwyGR;ADvyGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACyyGV;;ADhzGM;EACE,oCAAA;ACmzGR;ADlzGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACozGV;;AD3zGM;EACE,oCAAA;AC8zGR;AD7zGQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC+zGV;;ADt0GM;EACE,oCAAA;ACy0GR;ADx0GQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC00GV;;ADj1GM;EACE,oCAAA;ACo1GR;ADn1GQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACq1GV;;AD51GM;EACE,oCAAA;AC+1GR;AD91GQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACg2GV;;ADv2GM;EACE,oCAAA;AC02GR;ADz2GQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AC22GV;;ADl3GM;EACE,oCAAA;ACq3GR;ADp3GQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACs3GV;;AD73GM;EACE,oCAAA;ACg4GR;AD/3GQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;ACi4GV;;AChyHA;EAAE,UAAA;EAAW,SAAA;EAAU,sBAAA;EAAuB,+BAAA;ADuyH9C;;ACryHA;ECyBI,aAAA;EDvBA,sBAAA;EACA,iBAAA;AD4yHJ;;ACxyHI;EAAI,cAAA;AD4yHR;AC3yHI;EAAK,eAAA;AD8yHT;AC7yHI;EAAK,eAAA;ADgzHT;AC/yHI;EAAK,eAAA;ADkzHT;ACjzHI;EAAK,eAAA;ADozHT;ACnzHI;EAAK,eAAA;ADszHT;ACrzHI;EAAK,eAAA;ADwzHT;ACvzHI;EAAK,eAAA;AD0zHT;ACzzHI;EAAK,eAAA;AD4zHT;AC3zHI;EAAK,eAAA;AD8zHT;AC7zHI;EAAK,eAAA;ADg0HT;AC/zHI;EAAK,eAAA;EAAgB,iBAAA;ADm0HzB;ACl0HI;EAAK,eAAA;ADq0HT;ACp0HI;EAAK,eAAA;ADu0HT;ACt0HI;EAAK,eAAA;ADy0HT;ACx0HI;EAAK,eAAA;AD20HT;AC10HI;EAAK,eAAA;AD60HT;AC50HI;EAAK,eAAA;AD+0HT;AC90HI;EAAK,eAAA;ADi1HT;ACh1HI;EAAK,eAAA;ADm1HT;ACl1HI;EAAK,eAAA;ADq1HT;ACp1HI;EAAK,eAAA;ADu1HT;ACt1HI;EAAK,eAAA;ADy1HT;ACx1HI;EAAK,eAAA;AD21HT;ACz1HI;EAAM,gBAAA;AD41HV;AC31HI;EAAM,gBAAA;AD81HV;AC71HI;EAAM,gBAAA;ADg2HV;AC/1HI;EAAM,gBAAA;ADk2HV;ACj2HI;EAAM,gBAAA;ADo2HV;ACn2HI;EAAM,gBAAA;ADs2HV;ACr2HI;EAAM,gBAAA;ADw2HV;;ACp2HI;EAAY,cF/BJ;ACu4HZ;;ACr2HA;ECnCI,SAAA;AFg5HJ;;ACx2HI;EAAO,YAAA;AD42HX;AC32HI;EACI,gBAAA;EACA,WAAA;AD62HR;AC32HI;EACI,gBAAA;EACA,WAAA;AD62HR;AC32HI;EACI,gBAAA;EACA,WAAA;AD62HR;AC32HI;EACI,gBAAA;EACA,WAAA;AD62HR;AC32HI;EACI,iBAAA;EACA,WAAA;AD62HR;;ACx2HI;EAAK,YAAA;AD42HT;;ACx2HI;EAAM,iBAAA;AD42HV;;ACx2HI;EACI,4BAAA;EAGA,6EAAA;EACA,gHAAA;AD22HR;;ACt2HA;EACI,mBAAA;EACA,mBAAA;EACA,YAAA;ECtEA,aAAA;EDwEA,uBAAA;EACA,mBAAA;EACA,cF1FG;ACu8HP;AC52HI;EACI,mBAAA;AD82HR;;AC12HA;EChFI,aAAA;EDkFA,sBAAA;EACA,iBAAA;EACA,sBAAA;ADi3HJ;ACh3HI;ECpGA,SAAA;EDsGI,iCAAA;EACA,8HAAA;EACA,4BAAA;EACA,kCAAA;EACA,+BAAA;ADs3HR;ACp3HQ;EARJ;IASQ,kEAAA;EDi2HV;AACF;AAsBA;ECt3HQ,qHAAA;EACI,kCAAA;EACA,sBAAA;ADm2HZ;AAsBA;ECv3HY;IAJJ,sBAAA;EDy2HN;AACF;AAsBA;ECx3HQ,4BAAA;EACI,6EAAA;EAGA,gHAAA;ADm2HZ;AAwBA;ECx3HQ,gBAAA;EACI,aAAA;EChHR,4BAAA;EAsMA,oCDpF8B;ECqF9B,iCAAA;EACA,gCAAA;EACA,+BAAA;EACA,gBAAA;EDvFQ,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;ADu2HZ;AA4BA;ECh4HY,YAAA;EACI,WAAA;EACA,eAAA;ADu2HhB;AA4BA;EC/3HQ,eAAA;EACI,kBAAA;ADs2HZ;AA4BA;ECh4HY;IAHJ,eAAA;ED22HN;AACF;AA4BA;ECl4HY;IANJ,eAAA;EDg3HN;AACF;AA4BA;ECn4HQ,YAAA;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;ECwDR,0BDvD8B;ECwD9B,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;AFmzHJ;AA4BA;ECx4HY,WAAA;EACI,mBAAA;EACA,mBAAA;AD+2HhB;AA4BA;ECt4HQ,eAAA;EACI,iBAAA;EACA,kBAAA;AD62HZ;AA4BA;ECv4HY;IAJJ,eAAA;IAKQ,iBAAA;ED+2Hd;AACF;AA4BA;ECv4HQ,eAAA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;AD82HZ;AA4BA;ECz4HY;IAJJ,eAAA;IAKQ,iBAAA;EDi3Hd;AACF;AA4BA;ECz4HQ,mBAAA;EACI,aAAA;EC7KR,gBAAA;ED+KQ,kBAAA;ADg3HZ;AAgCA;EC94HY,kBAAA;EAEI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;ECgBZ,0BDfkC;ECgBlC,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,MAAA;EDlBY,YAAA;ADo3HhB;AAgCA;EC/4HQ,SAAA;EACI,UAAA;EACA,gBAAA;EACA,eAAA;ADk3HZ;AAgCA;EC/4HY;IANJ,eAAA;IAOQ,iBAAA;IACA,iBAAA;IACA,kBAAA;IACA,oBAAA;EDm3Hd;AACF;AAgCA;ECj5HY,kBAAA;EACI,kBAAA;ADo3HhB;AAgCA;ECl5HgB,WAAA;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,2IAAA;EACA,WAAA;EACA,YAAA;ADq3HpB;AAgCA;ECn5HoB;IARJ,WAAA;IASQ,YAAA;IACA,QAAA;EDu3HtB;AACF;AAgCA;ECp5HgB,mBAAA;ADu3HhB;AAgCA;ECj5HQ,eAAA;EACI,iBAAA;EACA,gBAAA;ADo3HZ;AAgCA;ECh5HQ,eAAA;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;ADm3HZ;AAgCA;ECj5HY;IAPJ,eAAA;IAQQ,iBAAA;IACA,gBAAA;IACA,gBAAA;EDq3Hd;AACF;AAgCA;ECj5HQ,WAAA;ADo3HR;AAgCA;ECh5HQ,iBAAA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;ECvDR,2BDwD8B;ECvD9B,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;EDqDQ,gBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EClQR,mBAAA;EDoQQ,gBAAA;EACA,eAAA;EACA,eAAA;ADu3HZ;AAoCA;ECz5HY,WAAA;EACI,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;ADw3HhB;AAoCA;ECt5HY,qBAAA;EACI,yBF5RH;ACipIb;AAoCA;ECp5HQ,YAAA;EACI,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EC5RR,uBAAA;ED8RQ,mBAAA;EACA,cAAA;ADm3HZ;AAwCA;ECz5HY,mBAAA;ADo3HZ;AAwCA;ECr5HQ,eAAA;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;ADg3HZ;AAwCA;ECt5HY;IALJ,eAAA;IAMQ,iBAAA;EDk3Hd;AACF;AAwCA;ECv5HQ,eAAA;EACI,kBAAA;ADk3HZ;AAwCA;ECx5HY;IAHJ,eAAA;EDu3HN;AACF;AAwCA;ECx5HI,YAAA;EACI,kBAAA;EACA,cAAA;ADm3HR;AAwCA;ECz5HQ,kBAAA;EACI,wBAAA;EACA,YAAA;ADo3HZ;AAwCA;ECz5HQ,WAAA;EACI,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;ECvUR,uBAAA;EDyUQ,mBAAA;EACA,cAAA;ADo3HZ;AA4CA;EC95HY,mBAAA;ADq3HZ;AA4CA;EC35HA,gBAAA;EACI,YAAA;EACA,SAAA;ADk3HJ;AA4CA;EC35HQ;IADJ,YAAA;EDo3HF;AACF;AA4CA;EC75HQ;IAJJ,YAAA;EDy3HF;AACF;AA4CA;EC75HI;IAbJ,YAAA;EDk4HE;AACF;AA4CA;EC95HI,kBAAA;EACI,OAAA;EACA,QAAA;EACA,wBAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EC1WJ,8BAAA;ED4WI,gBAAA;EACA,gBAAA;EACA,mBAAA;ECxKJ,2BDyK0B;ECxK1B,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EDsKI,cAAA;EACA,4DAAA;ADy3HR;AAgDA;ECt6HQ,WAAA;EACI,YAAA;EACA,aAAA;ECtXR,mBAAA;EAsMA,2BDmL8B;EClL9B,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EDgLQ,eAAA;EACA,yBAAA;EACA,cAAA;EACA,qBF7YL;EE8YK,gCAAA;AD43HZ;AAwDA;ECh7HgB,yDAAA;EACI,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AD23HpB;AAwDA;EC96HgB,yDAAA;EACI,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;ADy3HpB;AAwDA;EC56HY,yBAAA;EACI,qBAAA;ADu3HhB;AAwDA;EC36HY,qBAAA;ADs3HZ;;AAEA;EC92HA,kBAAA;EACI,OAAA;EACA,SAAA;EACA,UAAA;ADg3HJ;AAwDA;ECt6HI;IALJ,SAAA;EDu3HE;AACF;AAwDA;ECx6HI;IARJ,SAAA;ED43HE;AACF;AAwDA;EC16HI;IAXJ,SAAA;EDi4HE;AACF;AAwDA;EC56HI;IAdJ,OAAA;EDs4HE;AACF;AAwDA;EC96HI,WAAA;ADy3HJ;;AAEA;ECv3HE,kBAAA;EACE,QAAA;EACA,SAAA;EACA,UAAA;ADy3HJ;AAwDA;EC/6HI;IALF,SAAA;EDg4HA;AACF;AAwDA;ECj7HI;IARF,SAAA;EDq4HA;AACF;AAwDA;ECn7HI;IAXF,SAAA;ED04HA;AACF;AAwDA;ECr7HI;IAdF,QAAA;IAeM,UAAA;EDi4HN;AACF;AAwDA;ECv7HI,WAAA;ADk4HJ;;AAEA;EC93HE,gBAAA;EACD,gBAAA;EACA,cAAA;EACA,kBAAA;ADg4HD;AAwDA;ECt7HI;IALF,eAAA;IAMM,cAAA;EDk4HN;AACF;AAwDA;ECx7HI,eAAA;EACI,gBAAA;EACH,kBAAA;ADm4HL;AAwDA;ECz7HQ;IAJJ,eAAA;EDy4HF;AACF;AAwDA;EC37HQ,eAAA;EACI,gBAAA;EACA,kBAAA;ADs4HZ;AAwDA;EC57HY;IAJJ,eAAA;ED44HN;AACF;;AAEA;ECp4HI;IACI,gBAAA;EDs4HN;AACF;AAwDA;ECx7HI,qBAAA;EACI,qBAAA;EACA,gBAAA;ADm4HR;;AAEA;ECj4HM,WAAA;EACE,eAAA;EACA,sBAAA;ADm4HR;;AAEA;ECj4HM,UAAA;EACE,mBAAA;EACA,oBAAA,EAAA,sDAAA;EACA,qBAAA;EACA,kBAAA,EAAA,0CAAA;ADm4HR;;AAEA;ECj4HM,kBAAA,EAAA,kEAAA;EACE,qBAAA,EAAA,kCAAA;ADm4HR;;AAEA;ECx3HM,iBAAA;AD03HN","sourcesContent":["/*Primary Colors*/\n$primary-color:#0F0D2C;\n$secondary-color:#FF6580;\n\n$base-color:#0A0A0A;\n\n//dynamic height for form filed\n$lgform:50px;\n$mdform:40px;\n$smform:30px;\n\n/*Accent Colors*/\n\n$black:#000000;\n$white:#ffffff;\n\n$dark-gray: #3A3A3A;\n\n$beige-line: #F8B018;\n$purple-line: #51499C;\n$orange-line: #F05A2A;\n$green-line: #5CAE48;\n$pink-line: #ee4c61;\n\n\n$university: #51499C;\n$university-10: #49428c;\n$university-20: #413a7d;\n$university-30: #39336d;\n$university-40: #312c5e;\n$university-50: #29254e;\n$university-60: #201d3e;\n$university-70: #18162f;\n$university-80: #100f1f;\n$university-90: #080710;\n\n$university-lite-10: #625ba6;\n$university-lite-20: #746db0;\n$university-lite-30: #8580ba;\n$university-lite-40: #9792c4;\n$university-lite-50: #a8a4ce;\n$university-lite-60: #b9b6d7;\n$university-lite-70: #cbc8e1;\n$university-lite-80: #dcdbeb;\n$university-lite-90: #eeedf5;\n\n$primaryGreen: #5cae48;\n$primaryGreen-10: #539d41;\n$primaryGreen-20: #4a8b3a;\n$primaryGreen-30: #407a32;\n$primaryGreen-40: #37682b;\n$primaryGreen-50: #2e5724;\n$primaryGreen-60: #25461d;\n$primaryGreen-70: #1c3416;\n$primaryGreen-80: #12230e;\n$primaryGreen-90: #091107;\n\n$primaryGreen-lite-10: #6cb65a;\n$primaryGreen-lite-20: #7dbe6d;\n$primaryGreen-lite-30: #8dc67f;\n$primaryGreen-lite-40: #9dce91;\n$primaryGreen-lite-50: #aed7a4;\n$primaryGreen-lite-60: #bedfb6;\n$primaryGreen-lite-70: #cee7c8;\n$primaryGreen-lite-80: #deefda;\n$primaryGreen-lite-90: #eff7ed;\n\n$schools: #26a7df;\n$schools-10: #2296c9;\n$schools-20: #1e86b2;\n$schools-30: #1b759c;\n$schools-40: #176486;\n$schools-50: #135470;\n$schools-60: #0f4359;\n$schools-70: #0b3243;\n$schools-80: #08212d;\n$schools-90: #041116;\n\n$schools-lite-10: #3cb0e2;\n$schools-lite-20: #51b9e5;\n$schools-lite-30: #67c1e9;\n$schools-lite-40: #7dcaec;\n$schools-lite-50: #93d3ef;\n$schools-lite-60: #a8dcf2;\n$schools-lite-70: #bee5f5;\n$schools-lite-80: #d4edf9;\n$schools-lite-90: #e9f6fc;\n\n$primaryDarkBlue: #003457;\n$primaryDarkBlue-10: #002f4e;\n$primaryDarkBlue-20: #002a46;\n$primaryDarkBlue-30: #00243d;\n$primaryDarkBlue-40: #001f34;\n$primaryDarkBlue-50: #001a2c;\n$primaryDarkBlue-60: #001523;\n$primaryDarkBlue-70: #00101a;\n$primaryDarkBlue-80: #000a11;\n$primaryDarkBlue-90: #000509;\n\n$primaryDarkBlue-lite-10: #1a4868;\n$primaryDarkBlue-lite-20: #335d79;\n$primaryDarkBlue-lite-30: #4d7189;\n$primaryDarkBlue-lite-40: #66859a;\n$primaryDarkBlue-lite-50: #809aab;\n$primaryDarkBlue-lite-60: #99aebc;\n$primaryDarkBlue-lite-70: #b3c2cd;\n$primaryDarkBlue-lite-80: #ccd6dd;\n$primaryDarkBlue-lite-90: #ecebee;\n\n$alumni: #d42941;\n$alumni-10: #bf253b;\n$alumni-20: #aa2134;\n$alumni-30: #941d2e;\n$alumni-40: #7f1927;\n$alumni-50: #6a1521;\n$alumni-60: #55101a;\n$alumni-70: #400c13;\n$alumni-80: #2a080d;\n$alumni-90: #150406;\n  \n$alumni-lite-10: #d83e54;\n$alumni-lite-20: #dd5467;\n$alumni-lite-30: #e1697a;\n$alumni-lite-40: #e57f8d;\n$alumni-lite-50: #ea94a0;\n$alumni-lite-60: #eea9b3;\n$alumni-lite-70: #f2bfc6;\n$alumni-lite-80: #f6d4d9;\n$alumni-lite-90: #fbeaec;\n\n$counsellors: #f05a2a;\n$counsellors-10: #d85126;\n$counsellors-20: #c04822;\n$counsellors-30: #a83f1d;\n$counsellors-40: #903619;\n$counsellors-50: #782d15;\n$counsellors-60: #602411;\n$counsellors-70: #481b0d;\n$counsellors-80: #301208;\n$counsellors-90: #180904;\n\n$counsellors-lite-10: #f26b3f;\n$counsellors-lite-20: #f37b55;\n$counsellors-lite-30: #f58c6a;\n$counsellors-lite-40: #f69c7f;\n$counsellors-lite-50: #f8ad95;\n$counsellors-lite-60: #f9bdaa;\n$counsellors-lite-70: #fbcebf;\n$counsellors-lite-80: #fcded4;\n$counsellors-lite-90: #feefea;\n\n$students: #f8b018;\n$students-10: #df9e16;\n$students-20: #c68d13;\n$students-30: #ae7b11;\n$students-40: #956a0e;\n$students-50: #7c580c;\n$students-60: #63460a;\n$students-70: #4a3507;\n$students-80: #322305;\n$students-90: #191202;\n\n$students-lite-10: #f9b82f;\n$students-lite-20: #f9c046;\n$students-lite-30: #fac85d;\n$students-lite-40: #fbd074;\n$students-lite-50: #fcd88c;\n$students-lite-60: #fcdfa3;\n$students-lite-70: #fde7ba;\n$students-lite-80: #feefd1;\n$students-lite-90: #fef7e8;\n\n$parents: #f8b018;\n$parents-10: #df9e16;\n$parents-20: #c68d13;\n$parents-30: #ae7b11;\n$parents-40: #956a0e;\n$parents-50: #7c580c;\n$parents-60: #63460a;\n$parents-70: #4a3507;\n$parents-80: #322305;\n$parents-90: #191202;\n\n$parents-lite-10: #f9b82f;\n$parents-lite-20: #f9c046;\n$parents-lite-30: #fac85d;\n$parents-lite-40: #fbd074;\n$parents-lite-50: #fcd88c;\n$parents-lite-60: #fcdfa3;\n$parents-lite-70: #fde7ba;\n$parents-lite-80: #feefd1;\n$parents-lite-90: #fef7e8;\n\n$colors: (\n  university: (\n    0: #51499C,\n    10: #49428c,\n    20: #413a7d,\n    30: #39336d,\n    40: #312c5e,\n    50: #29254e,\n    60: #201d3e,\n    70: #18162f,\n    80: #100f1f,\n    90: #080710,\n    100: #000000\n  ),\n  university-lite: (\n    0: #51499c,\n    10: #625ba6,\n    20: #746db0,\n    30: #8580ba,\n    40: #9792c4,\n    50: #a8a4ce,\n    60: #b9b6d7,\n    70: #cbc8e1,\n    80: #dcdbeb,\n    90: #eeedf5,\n    100: #ffffff\n  ),\n  primaryGreen: (\n    0: #5cae48,\n    10: #539d41,\n    20: #4a8b3a,\n    30: #407a32,\n    40: #37682b,\n    50: #2e5724,\n    60: #25461d,\n    70: #1c3416,\n    80: #12230e,\n    90: #091107,\n    100: #000000\n  ),\n  primaryGreen-lite: (\n    0: #5cae48,\n    10: #6cb65a,\n    20: #7dbe6d,\n    30: #8dc67f,\n    40: #9dce91,\n    50: #aed7a4,\n    60: #bedfb6,\n    70: #cee7c8,\n    80: #deefda,\n    90: #eff7ed,\n    100: #ffffff\n  ),\n  schools: (\n    0: #26a7df,\n    10: #2296c9,\n    20: #1e86b2,\n    30: #1b759c,\n    40: #176486,\n    50: #135470,\n    60: #0f4359,\n    70: #0b3243,\n    80: #08212d,\n    90: #041116,\n    100: #000000\n  ),\n  schools-lite: (\n    0: #26a7df,\n    10: #3cb0e2,\n    20: #51b9e5,\n    30: #67c1e9,\n    40: #7dcaec,\n    50: #93d3ef,\n    60: #a8dcf2,\n    70: #bee5f5,\n    80: #d4edf9,\n    90: #e9f6fc,\n    100: #ffffff\n  ),\n  primaryDarkBlue: (\n    0: #003457,\n    10: #002f4e,\n    20: #002a46,\n    30: #00243d,\n    40: #001f34,\n    50: #001a2c,\n    60: #001523,\n    70: #00101a,\n    80: #000a11,\n    90: #000509,\n    100: #000000\n  ),\n  primaryDarkBlue-lite: (\n    0: #003457,\n    10: #1a4868,\n    20: #335d79,\n    30: #4d7189,\n    40: #66859a,\n    50: #809aab,\n    60: #99aebc,\n    70: #b3c2cd,\n    80: #ccd6dd,\n    90: #ecebee,\n    100: #ffffff\n  ),\n  alumni: (\n    0: #d42941,\n    10: #bf253b,\n    20: #aa2134,\n    30: #941d2e,\n    40: #7f1927,\n    50: #6a1521,\n    60: #55101a,\n    70: #400c13,\n    80: #2a080d,\n    90: #150406,\n    100: #000000\n  ),\n  alumni-lite: (\n    0: #d42941,\n    10: #d83e54,\n    20: #dd5467,\n    30: #e1697a,\n    40: #e57f8d,\n    50: #ea94a0,\n    60: #eea9b3,\n    70: #f2bfc6,\n    80: #f6d4d9,\n    90: #fbeaec,\n    100: #ffffff\n  ),\n  counsellors: (\n    0: #f05a2a,\n    10: #d85126,\n    20: #c04822,\n    30: #a83f1d,\n    40: #903619,\n    50: #782d15,\n    60: #602411,\n    70: #481b0d,\n    80: #301208,\n    90: #180904,\n    100: #000000\n  ),\n  counsellors-lite: (\n    0: #f05a2a,\n    10: #f26b3f,\n    20: #f37b55,\n    30: #f58c6a,\n    40: #f69c7f,\n    50: #f8ad95,\n    60: #f9bdaa,\n    70: #fbcebf,\n    80: #fcded4,\n    90: #feefea,\n    100: #ffffff\n  ),\n  students: (\n    0: #f8b018,\n    10: #df9e16,\n    20: #c68d13,\n    30: #ae7b11,\n    40: #956a0e,\n    50: #7c580c,\n    60: #63460a,\n    70: #4a3507,\n    80: #322305,\n    90: #191202,\n    100: #000000\n  ),\n  students-lite: (\n    0: #f8b018,\n    10: #f9b82f,\n    20: #f9c046,\n    30: #fac85d,\n    40: #fbd074,\n    50: #fcd88c,\n    60: #fcdfa3,\n    70: #fde7ba,\n    80: #feefd1,\n    90: #fef7e8,\n    100: #ffffff\n  ),\n  parents: (\n    0: #f8b018,\n    10: #df9e16,\n    20: #c68d13,\n    30: #ae7b11,\n    40: #956a0e,\n    50: #7c580c,\n    60: #63460a,\n    70: #4a3507,\n    80: #322305,\n    90: #191202,\n    100: #000000\n  ),\n  parents-lite: (\n    0: #f8b018,\n    10: #f9b82f,\n    20: #f9c046,\n    30: #fac85d,\n    40: #fbd074,\n    50: #fcd88c,\n    60: #fcdfa3,\n    70: #fde7ba,\n    80: #feefd1,\n    90: #fef7e8,\n    100: #ffffff\n  )\n);\n\n@each $color-key, $color-value in $colors {\n  @each $tone-key, $tone-value in $color-value {\n    @if $tone-key == base {\n      .#{$color-key} {\n        background-color: $tone-value !important;\n      }\n    } @else {\n      .#{$color-key}-#{$tone-key} {\n        background-color: $tone-value !important;\n        &::after{\n          content: '#{$tone-value}';\n          position: relative;\n          top: 30px;\n          display: flex;\n          justify-content: center;\n        }\n      }\n    }\n  }\n}","/*Primary Colors*/\n/*Accent Colors*/\n@import url(\"https://fonts.googleapis.com/css2?family=Jost:wght@100;200;300;400;500;600;700&display=swap\");\n.university-0 {\n  background-color: #51499C !important;\n}\n.university-0::after {\n  content: \"#51499C\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-10 {\n  background-color: #49428c !important;\n}\n.university-10::after {\n  content: \"#49428c\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-20 {\n  background-color: #413a7d !important;\n}\n.university-20::after {\n  content: \"#413a7d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-30 {\n  background-color: #39336d !important;\n}\n.university-30::after {\n  content: \"#39336d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-40 {\n  background-color: #312c5e !important;\n}\n.university-40::after {\n  content: \"#312c5e\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-50 {\n  background-color: #29254e !important;\n}\n.university-50::after {\n  content: \"#29254e\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-60 {\n  background-color: #201d3e !important;\n}\n.university-60::after {\n  content: \"#201d3e\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-70 {\n  background-color: #18162f !important;\n}\n.university-70::after {\n  content: \"#18162f\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-80 {\n  background-color: #100f1f !important;\n}\n.university-80::after {\n  content: \"#100f1f\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-90 {\n  background-color: #080710 !important;\n}\n.university-90::after {\n  content: \"#080710\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-100 {\n  background-color: #000000 !important;\n}\n.university-100::after {\n  content: \"#000000\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-0 {\n  background-color: #51499c !important;\n}\n.university-lite-0::after {\n  content: \"#51499c\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-10 {\n  background-color: #625ba6 !important;\n}\n.university-lite-10::after {\n  content: \"#625ba6\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-20 {\n  background-color: #746db0 !important;\n}\n.university-lite-20::after {\n  content: \"#746db0\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-30 {\n  background-color: #8580ba !important;\n}\n.university-lite-30::after {\n  content: \"#8580ba\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-40 {\n  background-color: #9792c4 !important;\n}\n.university-lite-40::after {\n  content: \"#9792c4\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-50 {\n  background-color: #a8a4ce !important;\n}\n.university-lite-50::after {\n  content: \"#a8a4ce\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-60 {\n  background-color: #b9b6d7 !important;\n}\n.university-lite-60::after {\n  content: \"#b9b6d7\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-70 {\n  background-color: #cbc8e1 !important;\n}\n.university-lite-70::after {\n  content: \"#cbc8e1\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-80 {\n  background-color: #dcdbeb !important;\n}\n.university-lite-80::after {\n  content: \"#dcdbeb\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-90 {\n  background-color: #eeedf5 !important;\n}\n.university-lite-90::after {\n  content: \"#eeedf5\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-100 {\n  background-color: #ffffff !important;\n}\n.university-lite-100::after {\n  content: \"#ffffff\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-0 {\n  background-color: #5cae48 !important;\n}\n.primaryGreen-0::after {\n  content: \"#5cae48\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-10 {\n  background-color: #539d41 !important;\n}\n.primaryGreen-10::after {\n  content: \"#539d41\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-20 {\n  background-color: #4a8b3a !important;\n}\n.primaryGreen-20::after {\n  content: \"#4a8b3a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-30 {\n  background-color: #407a32 !important;\n}\n.primaryGreen-30::after {\n  content: \"#407a32\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-40 {\n  background-color: #37682b !important;\n}\n.primaryGreen-40::after {\n  content: \"#37682b\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-50 {\n  background-color: #2e5724 !important;\n}\n.primaryGreen-50::after {\n  content: \"#2e5724\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-60 {\n  background-color: #25461d !important;\n}\n.primaryGreen-60::after {\n  content: \"#25461d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-70 {\n  background-color: #1c3416 !important;\n}\n.primaryGreen-70::after {\n  content: \"#1c3416\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-80 {\n  background-color: #12230e !important;\n}\n.primaryGreen-80::after {\n  content: \"#12230e\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-90 {\n  background-color: #091107 !important;\n}\n.primaryGreen-90::after {\n  content: \"#091107\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-100 {\n  background-color: #000000 !important;\n}\n.primaryGreen-100::after {\n  content: \"#000000\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-0 {\n  background-color: #5cae48 !important;\n}\n.primaryGreen-lite-0::after {\n  content: \"#5cae48\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-10 {\n  background-color: #6cb65a !important;\n}\n.primaryGreen-lite-10::after {\n  content: \"#6cb65a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-20 {\n  background-color: #7dbe6d !important;\n}\n.primaryGreen-lite-20::after {\n  content: \"#7dbe6d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-30 {\n  background-color: #8dc67f !important;\n}\n.primaryGreen-lite-30::after {\n  content: \"#8dc67f\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-40 {\n  background-color: #9dce91 !important;\n}\n.primaryGreen-lite-40::after {\n  content: \"#9dce91\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-50 {\n  background-color: #aed7a4 !important;\n}\n.primaryGreen-lite-50::after {\n  content: \"#aed7a4\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-60 {\n  background-color: #bedfb6 !important;\n}\n.primaryGreen-lite-60::after {\n  content: \"#bedfb6\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-70 {\n  background-color: #cee7c8 !important;\n}\n.primaryGreen-lite-70::after {\n  content: \"#cee7c8\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-80 {\n  background-color: #deefda !important;\n}\n.primaryGreen-lite-80::after {\n  content: \"#deefda\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-90 {\n  background-color: #eff7ed !important;\n}\n.primaryGreen-lite-90::after {\n  content: \"#eff7ed\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-100 {\n  background-color: #ffffff !important;\n}\n.primaryGreen-lite-100::after {\n  content: \"#ffffff\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-0 {\n  background-color: #26a7df !important;\n}\n.schools-0::after {\n  content: \"#26a7df\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-10 {\n  background-color: #2296c9 !important;\n}\n.schools-10::after {\n  content: \"#2296c9\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-20 {\n  background-color: #1e86b2 !important;\n}\n.schools-20::after {\n  content: \"#1e86b2\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-30 {\n  background-color: #1b759c !important;\n}\n.schools-30::after {\n  content: \"#1b759c\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-40 {\n  background-color: #176486 !important;\n}\n.schools-40::after {\n  content: \"#176486\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-50 {\n  background-color: #135470 !important;\n}\n.schools-50::after {\n  content: \"#135470\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-60 {\n  background-color: #0f4359 !important;\n}\n.schools-60::after {\n  content: \"#0f4359\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-70 {\n  background-color: #0b3243 !important;\n}\n.schools-70::after {\n  content: \"#0b3243\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-80 {\n  background-color: #08212d !important;\n}\n.schools-80::after {\n  content: \"#08212d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-90 {\n  background-color: #041116 !important;\n}\n.schools-90::after {\n  content: \"#041116\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-100 {\n  background-color: #000000 !important;\n}\n.schools-100::after {\n  content: \"#000000\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-0 {\n  background-color: #26a7df !important;\n}\n.schools-lite-0::after {\n  content: \"#26a7df\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-10 {\n  background-color: #3cb0e2 !important;\n}\n.schools-lite-10::after {\n  content: \"#3cb0e2\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-20 {\n  background-color: #51b9e5 !important;\n}\n.schools-lite-20::after {\n  content: \"#51b9e5\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-30 {\n  background-color: #67c1e9 !important;\n}\n.schools-lite-30::after {\n  content: \"#67c1e9\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-40 {\n  background-color: #7dcaec !important;\n}\n.schools-lite-40::after {\n  content: \"#7dcaec\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-50 {\n  background-color: #93d3ef !important;\n}\n.schools-lite-50::after {\n  content: \"#93d3ef\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-60 {\n  background-color: #a8dcf2 !important;\n}\n.schools-lite-60::after {\n  content: \"#a8dcf2\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-70 {\n  background-color: #bee5f5 !important;\n}\n.schools-lite-70::after {\n  content: \"#bee5f5\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-80 {\n  background-color: #d4edf9 !important;\n}\n.schools-lite-80::after {\n  content: \"#d4edf9\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-90 {\n  background-color: #e9f6fc !important;\n}\n.schools-lite-90::after {\n  content: \"#e9f6fc\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-100 {\n  background-color: #ffffff !important;\n}\n.schools-lite-100::after {\n  content: \"#ffffff\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-0 {\n  background-color: #003457 !important;\n}\n.primaryDarkBlue-0::after {\n  content: \"#003457\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-10 {\n  background-color: #002f4e !important;\n}\n.primaryDarkBlue-10::after {\n  content: \"#002f4e\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-20 {\n  background-color: #002a46 !important;\n}\n.primaryDarkBlue-20::after {\n  content: \"#002a46\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-30 {\n  background-color: #00243d !important;\n}\n.primaryDarkBlue-30::after {\n  content: \"#00243d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-40 {\n  background-color: #001f34 !important;\n}\n.primaryDarkBlue-40::after {\n  content: \"#001f34\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-50 {\n  background-color: #001a2c !important;\n}\n.primaryDarkBlue-50::after {\n  content: \"#001a2c\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-60 {\n  background-color: #001523 !important;\n}\n.primaryDarkBlue-60::after {\n  content: \"#001523\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-70 {\n  background-color: #00101a !important;\n}\n.primaryDarkBlue-70::after {\n  content: \"#00101a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-80 {\n  background-color: #000a11 !important;\n}\n.primaryDarkBlue-80::after {\n  content: \"#000a11\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-90 {\n  background-color: #000509 !important;\n}\n.primaryDarkBlue-90::after {\n  content: \"#000509\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-100 {\n  background-color: #000000 !important;\n}\n.primaryDarkBlue-100::after {\n  content: \"#000000\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-0 {\n  background-color: #003457 !important;\n}\n.primaryDarkBlue-lite-0::after {\n  content: \"#003457\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-10 {\n  background-color: #1a4868 !important;\n}\n.primaryDarkBlue-lite-10::after {\n  content: \"#1a4868\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-20 {\n  background-color: #335d79 !important;\n}\n.primaryDarkBlue-lite-20::after {\n  content: \"#335d79\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-30 {\n  background-color: #4d7189 !important;\n}\n.primaryDarkBlue-lite-30::after {\n  content: \"#4d7189\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-40 {\n  background-color: #66859a !important;\n}\n.primaryDarkBlue-lite-40::after {\n  content: \"#66859a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-50 {\n  background-color: #809aab !important;\n}\n.primaryDarkBlue-lite-50::after {\n  content: \"#809aab\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-60 {\n  background-color: #99aebc !important;\n}\n.primaryDarkBlue-lite-60::after {\n  content: \"#99aebc\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-70 {\n  background-color: #b3c2cd !important;\n}\n.primaryDarkBlue-lite-70::after {\n  content: \"#b3c2cd\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-80 {\n  background-color: #ccd6dd !important;\n}\n.primaryDarkBlue-lite-80::after {\n  content: \"#ccd6dd\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-90 {\n  background-color: #ecebee !important;\n}\n.primaryDarkBlue-lite-90::after {\n  content: \"#ecebee\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-100 {\n  background-color: #ffffff !important;\n}\n.primaryDarkBlue-lite-100::after {\n  content: \"#ffffff\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-0 {\n  background-color: #d42941 !important;\n}\n.alumni-0::after {\n  content: \"#d42941\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-10 {\n  background-color: #bf253b !important;\n}\n.alumni-10::after {\n  content: \"#bf253b\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-20 {\n  background-color: #aa2134 !important;\n}\n.alumni-20::after {\n  content: \"#aa2134\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-30 {\n  background-color: #941d2e !important;\n}\n.alumni-30::after {\n  content: \"#941d2e\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-40 {\n  background-color: #7f1927 !important;\n}\n.alumni-40::after {\n  content: \"#7f1927\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-50 {\n  background-color: #6a1521 !important;\n}\n.alumni-50::after {\n  content: \"#6a1521\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-60 {\n  background-color: #55101a !important;\n}\n.alumni-60::after {\n  content: \"#55101a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-70 {\n  background-color: #400c13 !important;\n}\n.alumni-70::after {\n  content: \"#400c13\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-80 {\n  background-color: #2a080d !important;\n}\n.alumni-80::after {\n  content: \"#2a080d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-90 {\n  background-color: #150406 !important;\n}\n.alumni-90::after {\n  content: \"#150406\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-100 {\n  background-color: #000000 !important;\n}\n.alumni-100::after {\n  content: \"#000000\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-0 {\n  background-color: #d42941 !important;\n}\n.alumni-lite-0::after {\n  content: \"#d42941\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-10 {\n  background-color: #d83e54 !important;\n}\n.alumni-lite-10::after {\n  content: \"#d83e54\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-20 {\n  background-color: #dd5467 !important;\n}\n.alumni-lite-20::after {\n  content: \"#dd5467\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-30 {\n  background-color: #e1697a !important;\n}\n.alumni-lite-30::after {\n  content: \"#e1697a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-40 {\n  background-color: #e57f8d !important;\n}\n.alumni-lite-40::after {\n  content: \"#e57f8d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-50 {\n  background-color: #ea94a0 !important;\n}\n.alumni-lite-50::after {\n  content: \"#ea94a0\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-60 {\n  background-color: #eea9b3 !important;\n}\n.alumni-lite-60::after {\n  content: \"#eea9b3\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-70 {\n  background-color: #f2bfc6 !important;\n}\n.alumni-lite-70::after {\n  content: \"#f2bfc6\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-80 {\n  background-color: #f6d4d9 !important;\n}\n.alumni-lite-80::after {\n  content: \"#f6d4d9\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-90 {\n  background-color: #fbeaec !important;\n}\n.alumni-lite-90::after {\n  content: \"#fbeaec\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-100 {\n  background-color: #ffffff !important;\n}\n.alumni-lite-100::after {\n  content: \"#ffffff\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-0 {\n  background-color: #f05a2a !important;\n}\n.counsellors-0::after {\n  content: \"#f05a2a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-10 {\n  background-color: #d85126 !important;\n}\n.counsellors-10::after {\n  content: \"#d85126\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-20 {\n  background-color: #c04822 !important;\n}\n.counsellors-20::after {\n  content: \"#c04822\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-30 {\n  background-color: #a83f1d !important;\n}\n.counsellors-30::after {\n  content: \"#a83f1d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-40 {\n  background-color: #903619 !important;\n}\n.counsellors-40::after {\n  content: \"#903619\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-50 {\n  background-color: #782d15 !important;\n}\n.counsellors-50::after {\n  content: \"#782d15\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-60 {\n  background-color: #602411 !important;\n}\n.counsellors-60::after {\n  content: \"#602411\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-70 {\n  background-color: #481b0d !important;\n}\n.counsellors-70::after {\n  content: \"#481b0d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-80 {\n  background-color: #301208 !important;\n}\n.counsellors-80::after {\n  content: \"#301208\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-90 {\n  background-color: #180904 !important;\n}\n.counsellors-90::after {\n  content: \"#180904\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-100 {\n  background-color: #000000 !important;\n}\n.counsellors-100::after {\n  content: \"#000000\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-0 {\n  background-color: #f05a2a !important;\n}\n.counsellors-lite-0::after {\n  content: \"#f05a2a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-10 {\n  background-color: #f26b3f !important;\n}\n.counsellors-lite-10::after {\n  content: \"#f26b3f\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-20 {\n  background-color: #f37b55 !important;\n}\n.counsellors-lite-20::after {\n  content: \"#f37b55\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-30 {\n  background-color: #f58c6a !important;\n}\n.counsellors-lite-30::after {\n  content: \"#f58c6a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-40 {\n  background-color: #f69c7f !important;\n}\n.counsellors-lite-40::after {\n  content: \"#f69c7f\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-50 {\n  background-color: #f8ad95 !important;\n}\n.counsellors-lite-50::after {\n  content: \"#f8ad95\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-60 {\n  background-color: #f9bdaa !important;\n}\n.counsellors-lite-60::after {\n  content: \"#f9bdaa\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-70 {\n  background-color: #fbcebf !important;\n}\n.counsellors-lite-70::after {\n  content: \"#fbcebf\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-80 {\n  background-color: #fcded4 !important;\n}\n.counsellors-lite-80::after {\n  content: \"#fcded4\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-90 {\n  background-color: #feefea !important;\n}\n.counsellors-lite-90::after {\n  content: \"#feefea\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-100 {\n  background-color: #ffffff !important;\n}\n.counsellors-lite-100::after {\n  content: \"#ffffff\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-0 {\n  background-color: #f8b018 !important;\n}\n.students-0::after {\n  content: \"#f8b018\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-10 {\n  background-color: #df9e16 !important;\n}\n.students-10::after {\n  content: \"#df9e16\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-20 {\n  background-color: #c68d13 !important;\n}\n.students-20::after {\n  content: \"#c68d13\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-30 {\n  background-color: #ae7b11 !important;\n}\n.students-30::after {\n  content: \"#ae7b11\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-40 {\n  background-color: #956a0e !important;\n}\n.students-40::after {\n  content: \"#956a0e\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-50 {\n  background-color: #7c580c !important;\n}\n.students-50::after {\n  content: \"#7c580c\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-60 {\n  background-color: #63460a !important;\n}\n.students-60::after {\n  content: \"#63460a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-70 {\n  background-color: #4a3507 !important;\n}\n.students-70::after {\n  content: \"#4a3507\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-80 {\n  background-color: #322305 !important;\n}\n.students-80::after {\n  content: \"#322305\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-90 {\n  background-color: #191202 !important;\n}\n.students-90::after {\n  content: \"#191202\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-100 {\n  background-color: #000000 !important;\n}\n.students-100::after {\n  content: \"#000000\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-0 {\n  background-color: #f8b018 !important;\n}\n.students-lite-0::after {\n  content: \"#f8b018\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-10 {\n  background-color: #f9b82f !important;\n}\n.students-lite-10::after {\n  content: \"#f9b82f\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-20 {\n  background-color: #f9c046 !important;\n}\n.students-lite-20::after {\n  content: \"#f9c046\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-30 {\n  background-color: #fac85d !important;\n}\n.students-lite-30::after {\n  content: \"#fac85d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-40 {\n  background-color: #fbd074 !important;\n}\n.students-lite-40::after {\n  content: \"#fbd074\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-50 {\n  background-color: #fcd88c !important;\n}\n.students-lite-50::after {\n  content: \"#fcd88c\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-60 {\n  background-color: #fcdfa3 !important;\n}\n.students-lite-60::after {\n  content: \"#fcdfa3\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-70 {\n  background-color: #fde7ba !important;\n}\n.students-lite-70::after {\n  content: \"#fde7ba\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-80 {\n  background-color: #feefd1 !important;\n}\n.students-lite-80::after {\n  content: \"#feefd1\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-90 {\n  background-color: #fef7e8 !important;\n}\n.students-lite-90::after {\n  content: \"#fef7e8\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-100 {\n  background-color: #ffffff !important;\n}\n.students-lite-100::after {\n  content: \"#ffffff\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-0 {\n  background-color: #f8b018 !important;\n}\n.parents-0::after {\n  content: \"#f8b018\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-10 {\n  background-color: #df9e16 !important;\n}\n.parents-10::after {\n  content: \"#df9e16\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-20 {\n  background-color: #c68d13 !important;\n}\n.parents-20::after {\n  content: \"#c68d13\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-30 {\n  background-color: #ae7b11 !important;\n}\n.parents-30::after {\n  content: \"#ae7b11\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-40 {\n  background-color: #956a0e !important;\n}\n.parents-40::after {\n  content: \"#956a0e\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-50 {\n  background-color: #7c580c !important;\n}\n.parents-50::after {\n  content: \"#7c580c\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-60 {\n  background-color: #63460a !important;\n}\n.parents-60::after {\n  content: \"#63460a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-70 {\n  background-color: #4a3507 !important;\n}\n.parents-70::after {\n  content: \"#4a3507\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-80 {\n  background-color: #322305 !important;\n}\n.parents-80::after {\n  content: \"#322305\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-90 {\n  background-color: #191202 !important;\n}\n.parents-90::after {\n  content: \"#191202\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-100 {\n  background-color: #000000 !important;\n}\n.parents-100::after {\n  content: \"#000000\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-0 {\n  background-color: #f8b018 !important;\n}\n.parents-lite-0::after {\n  content: \"#f8b018\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-10 {\n  background-color: #f9b82f !important;\n}\n.parents-lite-10::after {\n  content: \"#f9b82f\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-20 {\n  background-color: #f9c046 !important;\n}\n.parents-lite-20::after {\n  content: \"#f9c046\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-30 {\n  background-color: #fac85d !important;\n}\n.parents-lite-30::after {\n  content: \"#fac85d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-40 {\n  background-color: #fbd074 !important;\n}\n.parents-lite-40::after {\n  content: \"#fbd074\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-50 {\n  background-color: #fcd88c !important;\n}\n.parents-lite-50::after {\n  content: \"#fcd88c\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-60 {\n  background-color: #fcdfa3 !important;\n}\n.parents-lite-60::after {\n  content: \"#fcdfa3\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-70 {\n  background-color: #fde7ba !important;\n}\n.parents-lite-70::after {\n  content: \"#fde7ba\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-80 {\n  background-color: #feefd1 !important;\n}\n.parents-lite-80::after {\n  content: \"#feefd1\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-90 {\n  background-color: #fef7e8 !important;\n}\n.parents-lite-90::after {\n  content: \"#fef7e8\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-100 {\n  background-color: #ffffff !important;\n}\n.parents-lite-100::after {\n  content: \"#ffffff\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n/*Primary Colors*/\n/*Accent Colors*/\n.university-0 {\n  background-color: #51499C !important;\n}\n.university-0::after {\n  content: \"#51499C\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-10 {\n  background-color: #49428c !important;\n}\n.university-10::after {\n  content: \"#49428c\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-20 {\n  background-color: #413a7d !important;\n}\n.university-20::after {\n  content: \"#413a7d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-30 {\n  background-color: #39336d !important;\n}\n.university-30::after {\n  content: \"#39336d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-40 {\n  background-color: #312c5e !important;\n}\n.university-40::after {\n  content: \"#312c5e\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-50 {\n  background-color: #29254e !important;\n}\n.university-50::after {\n  content: \"#29254e\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-60 {\n  background-color: #201d3e !important;\n}\n.university-60::after {\n  content: \"#201d3e\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-70 {\n  background-color: #18162f !important;\n}\n.university-70::after {\n  content: \"#18162f\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-80 {\n  background-color: #100f1f !important;\n}\n.university-80::after {\n  content: \"#100f1f\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-90 {\n  background-color: #080710 !important;\n}\n.university-90::after {\n  content: \"#080710\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-100 {\n  background-color: #000000 !important;\n}\n.university-100::after {\n  content: \"#000000\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-0 {\n  background-color: #51499c !important;\n}\n.university-lite-0::after {\n  content: \"#51499c\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-10 {\n  background-color: #625ba6 !important;\n}\n.university-lite-10::after {\n  content: \"#625ba6\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-20 {\n  background-color: #746db0 !important;\n}\n.university-lite-20::after {\n  content: \"#746db0\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-30 {\n  background-color: #8580ba !important;\n}\n.university-lite-30::after {\n  content: \"#8580ba\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-40 {\n  background-color: #9792c4 !important;\n}\n.university-lite-40::after {\n  content: \"#9792c4\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-50 {\n  background-color: #a8a4ce !important;\n}\n.university-lite-50::after {\n  content: \"#a8a4ce\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-60 {\n  background-color: #b9b6d7 !important;\n}\n.university-lite-60::after {\n  content: \"#b9b6d7\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-70 {\n  background-color: #cbc8e1 !important;\n}\n.university-lite-70::after {\n  content: \"#cbc8e1\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-80 {\n  background-color: #dcdbeb !important;\n}\n.university-lite-80::after {\n  content: \"#dcdbeb\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-90 {\n  background-color: #eeedf5 !important;\n}\n.university-lite-90::after {\n  content: \"#eeedf5\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.university-lite-100 {\n  background-color: #ffffff !important;\n}\n.university-lite-100::after {\n  content: \"#ffffff\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-0 {\n  background-color: #5cae48 !important;\n}\n.primaryGreen-0::after {\n  content: \"#5cae48\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-10 {\n  background-color: #539d41 !important;\n}\n.primaryGreen-10::after {\n  content: \"#539d41\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-20 {\n  background-color: #4a8b3a !important;\n}\n.primaryGreen-20::after {\n  content: \"#4a8b3a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-30 {\n  background-color: #407a32 !important;\n}\n.primaryGreen-30::after {\n  content: \"#407a32\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-40 {\n  background-color: #37682b !important;\n}\n.primaryGreen-40::after {\n  content: \"#37682b\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-50 {\n  background-color: #2e5724 !important;\n}\n.primaryGreen-50::after {\n  content: \"#2e5724\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-60 {\n  background-color: #25461d !important;\n}\n.primaryGreen-60::after {\n  content: \"#25461d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-70 {\n  background-color: #1c3416 !important;\n}\n.primaryGreen-70::after {\n  content: \"#1c3416\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-80 {\n  background-color: #12230e !important;\n}\n.primaryGreen-80::after {\n  content: \"#12230e\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-90 {\n  background-color: #091107 !important;\n}\n.primaryGreen-90::after {\n  content: \"#091107\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-100 {\n  background-color: #000000 !important;\n}\n.primaryGreen-100::after {\n  content: \"#000000\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-0 {\n  background-color: #5cae48 !important;\n}\n.primaryGreen-lite-0::after {\n  content: \"#5cae48\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-10 {\n  background-color: #6cb65a !important;\n}\n.primaryGreen-lite-10::after {\n  content: \"#6cb65a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-20 {\n  background-color: #7dbe6d !important;\n}\n.primaryGreen-lite-20::after {\n  content: \"#7dbe6d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-30 {\n  background-color: #8dc67f !important;\n}\n.primaryGreen-lite-30::after {\n  content: \"#8dc67f\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-40 {\n  background-color: #9dce91 !important;\n}\n.primaryGreen-lite-40::after {\n  content: \"#9dce91\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-50 {\n  background-color: #aed7a4 !important;\n}\n.primaryGreen-lite-50::after {\n  content: \"#aed7a4\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-60 {\n  background-color: #bedfb6 !important;\n}\n.primaryGreen-lite-60::after {\n  content: \"#bedfb6\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-70 {\n  background-color: #cee7c8 !important;\n}\n.primaryGreen-lite-70::after {\n  content: \"#cee7c8\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-80 {\n  background-color: #deefda !important;\n}\n.primaryGreen-lite-80::after {\n  content: \"#deefda\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-90 {\n  background-color: #eff7ed !important;\n}\n.primaryGreen-lite-90::after {\n  content: \"#eff7ed\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryGreen-lite-100 {\n  background-color: #ffffff !important;\n}\n.primaryGreen-lite-100::after {\n  content: \"#ffffff\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-0 {\n  background-color: #26a7df !important;\n}\n.schools-0::after {\n  content: \"#26a7df\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-10 {\n  background-color: #2296c9 !important;\n}\n.schools-10::after {\n  content: \"#2296c9\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-20 {\n  background-color: #1e86b2 !important;\n}\n.schools-20::after {\n  content: \"#1e86b2\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-30 {\n  background-color: #1b759c !important;\n}\n.schools-30::after {\n  content: \"#1b759c\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-40 {\n  background-color: #176486 !important;\n}\n.schools-40::after {\n  content: \"#176486\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-50 {\n  background-color: #135470 !important;\n}\n.schools-50::after {\n  content: \"#135470\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-60 {\n  background-color: #0f4359 !important;\n}\n.schools-60::after {\n  content: \"#0f4359\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-70 {\n  background-color: #0b3243 !important;\n}\n.schools-70::after {\n  content: \"#0b3243\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-80 {\n  background-color: #08212d !important;\n}\n.schools-80::after {\n  content: \"#08212d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-90 {\n  background-color: #041116 !important;\n}\n.schools-90::after {\n  content: \"#041116\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-100 {\n  background-color: #000000 !important;\n}\n.schools-100::after {\n  content: \"#000000\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-0 {\n  background-color: #26a7df !important;\n}\n.schools-lite-0::after {\n  content: \"#26a7df\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-10 {\n  background-color: #3cb0e2 !important;\n}\n.schools-lite-10::after {\n  content: \"#3cb0e2\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-20 {\n  background-color: #51b9e5 !important;\n}\n.schools-lite-20::after {\n  content: \"#51b9e5\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-30 {\n  background-color: #67c1e9 !important;\n}\n.schools-lite-30::after {\n  content: \"#67c1e9\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-40 {\n  background-color: #7dcaec !important;\n}\n.schools-lite-40::after {\n  content: \"#7dcaec\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-50 {\n  background-color: #93d3ef !important;\n}\n.schools-lite-50::after {\n  content: \"#93d3ef\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-60 {\n  background-color: #a8dcf2 !important;\n}\n.schools-lite-60::after {\n  content: \"#a8dcf2\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-70 {\n  background-color: #bee5f5 !important;\n}\n.schools-lite-70::after {\n  content: \"#bee5f5\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-80 {\n  background-color: #d4edf9 !important;\n}\n.schools-lite-80::after {\n  content: \"#d4edf9\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-90 {\n  background-color: #e9f6fc !important;\n}\n.schools-lite-90::after {\n  content: \"#e9f6fc\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.schools-lite-100 {\n  background-color: #ffffff !important;\n}\n.schools-lite-100::after {\n  content: \"#ffffff\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-0 {\n  background-color: #003457 !important;\n}\n.primaryDarkBlue-0::after {\n  content: \"#003457\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-10 {\n  background-color: #002f4e !important;\n}\n.primaryDarkBlue-10::after {\n  content: \"#002f4e\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-20 {\n  background-color: #002a46 !important;\n}\n.primaryDarkBlue-20::after {\n  content: \"#002a46\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-30 {\n  background-color: #00243d !important;\n}\n.primaryDarkBlue-30::after {\n  content: \"#00243d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-40 {\n  background-color: #001f34 !important;\n}\n.primaryDarkBlue-40::after {\n  content: \"#001f34\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-50 {\n  background-color: #001a2c !important;\n}\n.primaryDarkBlue-50::after {\n  content: \"#001a2c\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-60 {\n  background-color: #001523 !important;\n}\n.primaryDarkBlue-60::after {\n  content: \"#001523\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-70 {\n  background-color: #00101a !important;\n}\n.primaryDarkBlue-70::after {\n  content: \"#00101a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-80 {\n  background-color: #000a11 !important;\n}\n.primaryDarkBlue-80::after {\n  content: \"#000a11\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-90 {\n  background-color: #000509 !important;\n}\n.primaryDarkBlue-90::after {\n  content: \"#000509\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-100 {\n  background-color: #000000 !important;\n}\n.primaryDarkBlue-100::after {\n  content: \"#000000\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-0 {\n  background-color: #003457 !important;\n}\n.primaryDarkBlue-lite-0::after {\n  content: \"#003457\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-10 {\n  background-color: #1a4868 !important;\n}\n.primaryDarkBlue-lite-10::after {\n  content: \"#1a4868\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-20 {\n  background-color: #335d79 !important;\n}\n.primaryDarkBlue-lite-20::after {\n  content: \"#335d79\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-30 {\n  background-color: #4d7189 !important;\n}\n.primaryDarkBlue-lite-30::after {\n  content: \"#4d7189\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-40 {\n  background-color: #66859a !important;\n}\n.primaryDarkBlue-lite-40::after {\n  content: \"#66859a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-50 {\n  background-color: #809aab !important;\n}\n.primaryDarkBlue-lite-50::after {\n  content: \"#809aab\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-60 {\n  background-color: #99aebc !important;\n}\n.primaryDarkBlue-lite-60::after {\n  content: \"#99aebc\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-70 {\n  background-color: #b3c2cd !important;\n}\n.primaryDarkBlue-lite-70::after {\n  content: \"#b3c2cd\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-80 {\n  background-color: #ccd6dd !important;\n}\n.primaryDarkBlue-lite-80::after {\n  content: \"#ccd6dd\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-90 {\n  background-color: #ecebee !important;\n}\n.primaryDarkBlue-lite-90::after {\n  content: \"#ecebee\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.primaryDarkBlue-lite-100 {\n  background-color: #ffffff !important;\n}\n.primaryDarkBlue-lite-100::after {\n  content: \"#ffffff\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-0 {\n  background-color: #d42941 !important;\n}\n.alumni-0::after {\n  content: \"#d42941\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-10 {\n  background-color: #bf253b !important;\n}\n.alumni-10::after {\n  content: \"#bf253b\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-20 {\n  background-color: #aa2134 !important;\n}\n.alumni-20::after {\n  content: \"#aa2134\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-30 {\n  background-color: #941d2e !important;\n}\n.alumni-30::after {\n  content: \"#941d2e\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-40 {\n  background-color: #7f1927 !important;\n}\n.alumni-40::after {\n  content: \"#7f1927\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-50 {\n  background-color: #6a1521 !important;\n}\n.alumni-50::after {\n  content: \"#6a1521\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-60 {\n  background-color: #55101a !important;\n}\n.alumni-60::after {\n  content: \"#55101a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-70 {\n  background-color: #400c13 !important;\n}\n.alumni-70::after {\n  content: \"#400c13\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-80 {\n  background-color: #2a080d !important;\n}\n.alumni-80::after {\n  content: \"#2a080d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-90 {\n  background-color: #150406 !important;\n}\n.alumni-90::after {\n  content: \"#150406\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-100 {\n  background-color: #000000 !important;\n}\n.alumni-100::after {\n  content: \"#000000\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-0 {\n  background-color: #d42941 !important;\n}\n.alumni-lite-0::after {\n  content: \"#d42941\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-10 {\n  background-color: #d83e54 !important;\n}\n.alumni-lite-10::after {\n  content: \"#d83e54\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-20 {\n  background-color: #dd5467 !important;\n}\n.alumni-lite-20::after {\n  content: \"#dd5467\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-30 {\n  background-color: #e1697a !important;\n}\n.alumni-lite-30::after {\n  content: \"#e1697a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-40 {\n  background-color: #e57f8d !important;\n}\n.alumni-lite-40::after {\n  content: \"#e57f8d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-50 {\n  background-color: #ea94a0 !important;\n}\n.alumni-lite-50::after {\n  content: \"#ea94a0\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-60 {\n  background-color: #eea9b3 !important;\n}\n.alumni-lite-60::after {\n  content: \"#eea9b3\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-70 {\n  background-color: #f2bfc6 !important;\n}\n.alumni-lite-70::after {\n  content: \"#f2bfc6\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-80 {\n  background-color: #f6d4d9 !important;\n}\n.alumni-lite-80::after {\n  content: \"#f6d4d9\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-90 {\n  background-color: #fbeaec !important;\n}\n.alumni-lite-90::after {\n  content: \"#fbeaec\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.alumni-lite-100 {\n  background-color: #ffffff !important;\n}\n.alumni-lite-100::after {\n  content: \"#ffffff\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-0 {\n  background-color: #f05a2a !important;\n}\n.counsellors-0::after {\n  content: \"#f05a2a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-10 {\n  background-color: #d85126 !important;\n}\n.counsellors-10::after {\n  content: \"#d85126\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-20 {\n  background-color: #c04822 !important;\n}\n.counsellors-20::after {\n  content: \"#c04822\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-30 {\n  background-color: #a83f1d !important;\n}\n.counsellors-30::after {\n  content: \"#a83f1d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-40 {\n  background-color: #903619 !important;\n}\n.counsellors-40::after {\n  content: \"#903619\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-50 {\n  background-color: #782d15 !important;\n}\n.counsellors-50::after {\n  content: \"#782d15\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-60 {\n  background-color: #602411 !important;\n}\n.counsellors-60::after {\n  content: \"#602411\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-70 {\n  background-color: #481b0d !important;\n}\n.counsellors-70::after {\n  content: \"#481b0d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-80 {\n  background-color: #301208 !important;\n}\n.counsellors-80::after {\n  content: \"#301208\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-90 {\n  background-color: #180904 !important;\n}\n.counsellors-90::after {\n  content: \"#180904\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-100 {\n  background-color: #000000 !important;\n}\n.counsellors-100::after {\n  content: \"#000000\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-0 {\n  background-color: #f05a2a !important;\n}\n.counsellors-lite-0::after {\n  content: \"#f05a2a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-10 {\n  background-color: #f26b3f !important;\n}\n.counsellors-lite-10::after {\n  content: \"#f26b3f\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-20 {\n  background-color: #f37b55 !important;\n}\n.counsellors-lite-20::after {\n  content: \"#f37b55\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-30 {\n  background-color: #f58c6a !important;\n}\n.counsellors-lite-30::after {\n  content: \"#f58c6a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-40 {\n  background-color: #f69c7f !important;\n}\n.counsellors-lite-40::after {\n  content: \"#f69c7f\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-50 {\n  background-color: #f8ad95 !important;\n}\n.counsellors-lite-50::after {\n  content: \"#f8ad95\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-60 {\n  background-color: #f9bdaa !important;\n}\n.counsellors-lite-60::after {\n  content: \"#f9bdaa\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-70 {\n  background-color: #fbcebf !important;\n}\n.counsellors-lite-70::after {\n  content: \"#fbcebf\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-80 {\n  background-color: #fcded4 !important;\n}\n.counsellors-lite-80::after {\n  content: \"#fcded4\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-90 {\n  background-color: #feefea !important;\n}\n.counsellors-lite-90::after {\n  content: \"#feefea\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.counsellors-lite-100 {\n  background-color: #ffffff !important;\n}\n.counsellors-lite-100::after {\n  content: \"#ffffff\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-0 {\n  background-color: #f8b018 !important;\n}\n.students-0::after {\n  content: \"#f8b018\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-10 {\n  background-color: #df9e16 !important;\n}\n.students-10::after {\n  content: \"#df9e16\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-20 {\n  background-color: #c68d13 !important;\n}\n.students-20::after {\n  content: \"#c68d13\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-30 {\n  background-color: #ae7b11 !important;\n}\n.students-30::after {\n  content: \"#ae7b11\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-40 {\n  background-color: #956a0e !important;\n}\n.students-40::after {\n  content: \"#956a0e\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-50 {\n  background-color: #7c580c !important;\n}\n.students-50::after {\n  content: \"#7c580c\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-60 {\n  background-color: #63460a !important;\n}\n.students-60::after {\n  content: \"#63460a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-70 {\n  background-color: #4a3507 !important;\n}\n.students-70::after {\n  content: \"#4a3507\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-80 {\n  background-color: #322305 !important;\n}\n.students-80::after {\n  content: \"#322305\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-90 {\n  background-color: #191202 !important;\n}\n.students-90::after {\n  content: \"#191202\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-100 {\n  background-color: #000000 !important;\n}\n.students-100::after {\n  content: \"#000000\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-0 {\n  background-color: #f8b018 !important;\n}\n.students-lite-0::after {\n  content: \"#f8b018\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-10 {\n  background-color: #f9b82f !important;\n}\n.students-lite-10::after {\n  content: \"#f9b82f\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-20 {\n  background-color: #f9c046 !important;\n}\n.students-lite-20::after {\n  content: \"#f9c046\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-30 {\n  background-color: #fac85d !important;\n}\n.students-lite-30::after {\n  content: \"#fac85d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-40 {\n  background-color: #fbd074 !important;\n}\n.students-lite-40::after {\n  content: \"#fbd074\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-50 {\n  background-color: #fcd88c !important;\n}\n.students-lite-50::after {\n  content: \"#fcd88c\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-60 {\n  background-color: #fcdfa3 !important;\n}\n.students-lite-60::after {\n  content: \"#fcdfa3\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-70 {\n  background-color: #fde7ba !important;\n}\n.students-lite-70::after {\n  content: \"#fde7ba\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-80 {\n  background-color: #feefd1 !important;\n}\n.students-lite-80::after {\n  content: \"#feefd1\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-90 {\n  background-color: #fef7e8 !important;\n}\n.students-lite-90::after {\n  content: \"#fef7e8\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.students-lite-100 {\n  background-color: #ffffff !important;\n}\n.students-lite-100::after {\n  content: \"#ffffff\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-0 {\n  background-color: #f8b018 !important;\n}\n.parents-0::after {\n  content: \"#f8b018\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-10 {\n  background-color: #df9e16 !important;\n}\n.parents-10::after {\n  content: \"#df9e16\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-20 {\n  background-color: #c68d13 !important;\n}\n.parents-20::after {\n  content: \"#c68d13\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-30 {\n  background-color: #ae7b11 !important;\n}\n.parents-30::after {\n  content: \"#ae7b11\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-40 {\n  background-color: #956a0e !important;\n}\n.parents-40::after {\n  content: \"#956a0e\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-50 {\n  background-color: #7c580c !important;\n}\n.parents-50::after {\n  content: \"#7c580c\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-60 {\n  background-color: #63460a !important;\n}\n.parents-60::after {\n  content: \"#63460a\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-70 {\n  background-color: #4a3507 !important;\n}\n.parents-70::after {\n  content: \"#4a3507\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-80 {\n  background-color: #322305 !important;\n}\n.parents-80::after {\n  content: \"#322305\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-90 {\n  background-color: #191202 !important;\n}\n.parents-90::after {\n  content: \"#191202\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-100 {\n  background-color: #000000 !important;\n}\n.parents-100::after {\n  content: \"#000000\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-0 {\n  background-color: #f8b018 !important;\n}\n.parents-lite-0::after {\n  content: \"#f8b018\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-10 {\n  background-color: #f9b82f !important;\n}\n.parents-lite-10::after {\n  content: \"#f9b82f\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-20 {\n  background-color: #f9c046 !important;\n}\n.parents-lite-20::after {\n  content: \"#f9c046\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-30 {\n  background-color: #fac85d !important;\n}\n.parents-lite-30::after {\n  content: \"#fac85d\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-40 {\n  background-color: #fbd074 !important;\n}\n.parents-lite-40::after {\n  content: \"#fbd074\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-50 {\n  background-color: #fcd88c !important;\n}\n.parents-lite-50::after {\n  content: \"#fcd88c\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-60 {\n  background-color: #fcdfa3 !important;\n}\n.parents-lite-60::after {\n  content: \"#fcdfa3\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-70 {\n  background-color: #fde7ba !important;\n}\n.parents-lite-70::after {\n  content: \"#fde7ba\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-80 {\n  background-color: #feefd1 !important;\n}\n.parents-lite-80::after {\n  content: \"#feefd1\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-90 {\n  background-color: #fef7e8 !important;\n}\n.parents-lite-90::after {\n  content: \"#fef7e8\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.parents-lite-100 {\n  background-color: #ffffff !important;\n}\n.parents-lite-100::after {\n  content: \"#ffffff\";\n  position: relative;\n  top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  font-family: \"Jost\", sans-serif;\n}\n\nbody {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.font-9 {\n  font-size: 9px;\n}\n.font-10 {\n  font-size: 10px;\n}\n.font-11 {\n  font-size: 11px;\n}\n.font-12 {\n  font-size: 12px;\n}\n.font-13 {\n  font-size: 13px;\n}\n.font-14 {\n  font-size: 14px;\n}\n.font-15 {\n  font-size: 15px;\n}\n.font-16 {\n  font-size: 16px;\n}\n.font-17 {\n  font-size: 17px;\n}\n.font-18 {\n  font-size: 18px;\n}\n.font-19 {\n  font-size: 19px;\n}\n.font-20 {\n  font-size: 20px;\n  line-height: 22px;\n}\n.font-21 {\n  font-size: 21px;\n}\n.font-22 {\n  font-size: 22px;\n}\n.font-23 {\n  font-size: 23px;\n}\n.font-24 {\n  font-size: 24px;\n}\n.font-25 {\n  font-size: 25px;\n}\n.font-26 {\n  font-size: 26px;\n}\n.font-27 {\n  font-size: 27px;\n}\n.font-28 {\n  font-size: 28px;\n}\n.font-29 {\n  font-size: 29px;\n}\n.font-30 {\n  font-size: 30px;\n}\n.font-31 {\n  font-size: 31px;\n}\n.font-32 {\n  font-size: 32px;\n}\n.font-100 {\n  font-weight: 100;\n}\n.font-300 {\n  font-weight: 300;\n}\n.font-400 {\n  font-weight: 400;\n}\n.font-500 {\n  font-weight: 500;\n}\n.font-600 {\n  font-weight: 600;\n}\n.font-700 {\n  font-weight: 700;\n}\n.font-900 {\n  font-weight: 900;\n}\n\n.text-dark-gray {\n  color: #3A3A3A;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.w-140 {\n  width: 140px;\n}\n.w-270 {\n  max-width: 270px;\n  width: 100%;\n}\n.w-312 {\n  max-width: 312px;\n  width: 100%;\n}\n.w-800 {\n  max-width: 800px;\n  width: 100%;\n}\n.w-860 {\n  max-width: 860px;\n  width: 100%;\n}\n.w-1030 {\n  max-width: 1030px;\n  width: 100%;\n}\n\n.height-46 {\n  height: 46px;\n}\n\n.min-height-250 {\n  min-height: 250px;\n}\n\n.bg-grd-blue {\n  background: rgb(23, 76, 117);\n  background: radial-gradient(circle, rgb(23, 76, 117) 0%, rgb(9, 50, 83) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#174c75\",endColorstr=\"#093253\",GradientType=1);\n}\n\n.btn-green {\n  background: #5CAE48;\n  border-radius: 25px;\n  height: 36px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #ffffff;\n}\n.btn-green:hover {\n  background: #f8b018;\n}\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background-color: #fff;\n}\n.wrapper .dark-section {\n  flex: 1;\n  background-color: rgb(11, 52, 84);\n  background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/collage-building.svg);\n  background-repeat: no-repeat;\n  background-position: right top 30%;\n  background-blend-mode: multiply;\n}\n@media (max-width: 575px) {\n  .wrapper .dark-section {\n    clip-path: polygon(50% 0%, 100% 0, 100% 93%, 50% 100%, 0 93%, 0 0);\n  }\n}\n.wrapper .dark-section.student-img {\n  background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/gradute.svg);\n  background-position: bottom center;\n  background-size: 800px;\n}\n@media (max-width: 575px) {\n  .wrapper .dark-section.student-img {\n    background-size: 450px;\n  }\n}\n.wrapper .dark-section.bg-grd-blue {\n  background: rgb(23, 76, 117);\n  background: radial-gradient(circle, rgb(23, 76, 117) 0%, rgb(9, 50, 83) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#174c75\",endColorstr=\"#093253\",GradientType=1);\n}\n.wrapper .dark-section .logo {\n  background: #fff;\n  display: flex;\n  border-radius: 0 0 10px 10px;\n  -webkit-border-radius: 0 0 10px 10px;\n  -moz-border-radius: 0 0 10px 10px;\n  -ms-border-radius: 0 0 10px 10px;\n  -o-border-radius: 0 0 10px 10px;\n  align-items: end;\n  justify-content: center;\n  margin: 0 auto;\n  padding: 15px 30px;\n  max-width: 300px;\n  max-height: 230px;\n  min-width: 300px;\n}\n.wrapper .dark-section .logo img {\n  height: 100%;\n  width: auto;\n  max-width: 100%;\n}\n.wrapper .dark-section .home-page-title {\n  font-size: 40px;\n  text-align: center;\n}\n@media (max-width: 1024px) {\n  .wrapper .dark-section .home-page-title {\n    font-size: 30px;\n  }\n}\n@media (max-width: 767px) {\n  .wrapper .dark-section .home-page-title {\n    font-size: 23px;\n  }\n}\n.wrapper .dark-section .sep {\n  width: 285px;\n  height: 2px;\n  background: #fff;\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n  margin: 30px 0;\n}\n.wrapper .dark-section .sep.blue {\n  height: 2px;\n  background: #2B6B9F;\n  margin: 15px 0 45px;\n}\n.wrapper .dark-section .school-name {\n  font-size: 45px;\n  line-height: 50px;\n  text-align: center;\n}\n@media (max-width: 1024px) {\n  .wrapper .dark-section .school-name {\n    font-size: 50px;\n    line-height: 60px;\n  }\n}\n.wrapper .dark-section .sub-school-tag {\n  font-size: 36px;\n  text-align: center;\n  line-height: 51px;\n  font-weight: 500;\n}\n@media (max-width: 1024px) {\n  .wrapper .dark-section .sub-school-tag {\n    font-size: 30px;\n    line-height: 34px;\n  }\n}\n.wrapper .dark-section .header-icon {\n  margin-bottom: 22px;\n  display: flex;\n  align-items: end;\n  position: relative;\n}\n.wrapper .dark-section .header-icon::before {\n  position: absolute;\n  width: 50px;\n  height: 50px;\n  background: #022642;\n  border-radius: 50%;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  top: 0;\n  right: -10px;\n}\n.wrapper .dark-section .list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  font-size: 30px;\n}\n@media (max-width: 575px) {\n  .wrapper .dark-section .list {\n    font-size: 20px;\n    line-height: 30px;\n    padding-top: 40px;\n    padding-left: 40px;\n    padding-bottom: 50px;\n  }\n}\n.wrapper .dark-section .list li {\n  position: relative;\n  padding-left: 40px;\n}\n.wrapper .dark-section .list li::before {\n  content: \"\";\n  position: absolute;\n  top: 9px;\n  left: 0;\n  background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/green-check.svg) no-repeat left top/100%;\n  width: 24px;\n  height: 24px;\n}\n@media (max-width: 575px) {\n  .wrapper .dark-section .list li::before {\n    width: 20px;\n    height: 20px;\n    top: 5px;\n  }\n}\n.wrapper .dark-section .list li:not(:last-child) {\n  margin-bottom: 30px;\n}\n.wrapper .dark-section .id-title {\n  font-size: 30px;\n  line-height: 45px;\n  font-weight: 600;\n}\n.wrapper .dark-section .form-title {\n  font-size: 32px;\n  line-height: 40px;\n  text-align: center;\n  font-weight: 600;\n  border: none;\n  color: #fff;\n}\n@media (max-width: 575px) {\n  .wrapper .dark-section .form-title {\n    font-size: 20px;\n    line-height: 26px;\n    text-align: left;\n    font-weight: 500;\n  }\n}\n.wrapper .dark-section .form-label {\n  color: #fff;\n}\n.wrapper .dark-section .white-label {\n  background: white;\n  width: 100%;\n  height: 60px;\n  border-radius: 35px;\n  -webkit-border-radius: 35px;\n  -moz-border-radius: 35px;\n  -ms-border-radius: 35px;\n  -o-border-radius: 35px;\n  max-width: 200px;\n  min-width: 200px;\n  padding: 0 25px;\n  color: black;\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  font-size: 18px;\n  cursor: pointer;\n}\n.wrapper .dark-section .white-label i {\n  width: 13px;\n  height: 13px;\n  border: 1px solid #666666;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n.wrapper .dark-section .form-check-input:checked + .white-label i {\n  border-color: #5CAE48;\n  background-color: #5CAE48;\n}\n.wrapper .dark-section .btn-submit {\n  width: 140px;\n  background: #5CAE48;\n  border-radius: 25px;\n  height: 36px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #ffffff;\n}\n.wrapper .dark-section .btn-submit:hover {\n  background: #f8b018;\n}\n.wrapper .footer-text-1 {\n  font-size: 36px;\n  line-height: 45px;\n  font-weight: 600;\n  text-align: center;\n}\n@media (max-width: 1024px) {\n  .wrapper .footer-text-1 {\n    font-size: 24px;\n    line-height: 32px;\n  }\n}\n.wrapper .footer-text-2 {\n  font-size: 30px;\n  text-align: center;\n}\n@media (max-width: 1024px) {\n  .wrapper .footer-text-2 {\n    font-size: 24px;\n  }\n}\n.wrapper .principal-wrap {\n  width: 281px;\n  position: relative;\n  margin: 0 auto;\n}\n.wrapper .principal-wrap .arrow-img {\n  position: absolute;\n  right: calc(100% + 10px);\n  bottom: 10px;\n}\n.wrapper .principal-wrap .btn-green {\n  width: 100%;\n  background: #5CAE48;\n  border-radius: 25px;\n  height: 44px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #ffffff;\n}\n.wrapper .principal-wrap .btn-green:hover {\n  background: #f8b018;\n}\n.wrapper .navigation_footer_wrap {\n  position: sticky;\n  bottom: 30px;\n  height: 0;\n}\n@media (max-width: 1366px) {\n  .wrapper .navigation_footer_wrap:not(.homePageLink) {\n    bottom: 80px;\n  }\n}\n@media (min-width: 768px) {\n  .wrapper .navigation_footer_wrap:not(.homePageLink) {\n    bottom: 80px;\n  }\n}\n@media (max-width: 575px) {\n  .wrapper .navigation_footer_wrap {\n    height: 50px;\n  }\n}\n.wrapper .navigation_footer_wrap .navigation_footer {\n  position: absolute;\n  left: 0;\n  right: 0;\n  width: calc(100% - 80px);\n  height: 55px;\n  margin: auto;\n  bottom: 0;\n  display: flex;\n  justify-content: space-between;\n  max-width: 250px;\n  background: #fff;\n  border-radius: 25px;\n  -webkit-border-radius: 25px;\n  -moz-border-radius: 25px;\n  -ms-border-radius: 25px;\n  -o-border-radius: 25px;\n  align-items: center;\n  padding: 0 5px;\n  box-shadow: 0 0px 10px 1px rgba(118, 118, 118, 0.1803921569);\n}\n.wrapper .navigation_footer_wrap .navigation_footer a {\n  width: auto;\n  height: 45px;\n  display: flex;\n  border-radius: 25px;\n  -webkit-border-radius: 25px;\n  -moz-border-radius: 25px;\n  -ms-border-radius: 25px;\n  -o-border-radius: 25px;\n  align-items: center;\n  padding: 0 20px;\n  background-color: #5CAE48;\n  color: #ffffff;\n  text-decoration: none;\n  transition: all 0.3s ease-in-out;\n}\n.wrapper .navigation_footer_wrap .navigation_footer a.btn-back i {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='white' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 16px 12px;\n  width: 10px;\n  height: 20px;\n  margin-right: 7px;\n}\n.wrapper .navigation_footer_wrap .navigation_footer a.btn-next i {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='white' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 16px 12px;\n  width: 10px;\n  height: 20px;\n  margin-left: 7px;\n}\n.wrapper .navigation_footer_wrap .navigation_footer a:hover {\n  background-color: #35911f;\n  text-decoration: none;\n}\n.wrapper .navigation_footer_wrap .navigation_footer a span {\n  text-decoration: none;\n}\n\n.left-graph {\n  position: absolute;\n  left: 0;\n  top: -40%;\n  width: 50%;\n}\n@media (max-width: 1500px) {\n  .left-graph {\n    top: -30%;\n  }\n}\n@media (max-width: 1250px) {\n  .left-graph {\n    top: -20%;\n  }\n}\n@media (max-width: 1100px) {\n  .left-graph {\n    top: -10%;\n  }\n}\n@media (max-width: 575px) {\n  .left-graph {\n    top: 0%;\n  }\n}\n.left-graph img {\n  width: 100%;\n}\n\n.right-graph {\n  position: absolute;\n  right: 0;\n  top: -71%;\n  width: 50%;\n}\n@media (max-width: 1500px) {\n  .right-graph {\n    top: -50%;\n  }\n}\n@media (max-width: 1250px) {\n  .right-graph {\n    top: -40%;\n  }\n}\n@media (max-width: 1100px) {\n  .right-graph {\n    top: -30%;\n  }\n}\n@media (max-width: 575px) {\n  .right-graph {\n    top: -9%;\n    width: 70%;\n  }\n}\n.right-graph img {\n  width: 100%;\n}\n\n.thanksTxt {\n  font-size: 100px;\n  font-weight: 700;\n  margin: 30px 0;\n  font-style: italic;\n}\n@media (max-width: 1100px) {\n  .thanksTxt {\n    font-size: 60px;\n    margin: 20px 0;\n  }\n}\n.thanksTxt-sub {\n  font-size: 36px;\n  font-weight: 600;\n  text-align: center;\n}\n@media (max-width: 575px) {\n  .thanksTxt-sub {\n    font-size: 24px;\n  }\n}\n.thanksTxt-sub-2 {\n  font-size: 46px;\n  font-weight: 600;\n  text-align: center;\n}\n@media (max-width: 575px) {\n  .thanksTxt-sub-2 {\n    font-size: 30px;\n  }\n}\n\n@media (max-width: 1100px) {\n  .thumb img {\n    max-width: 130px;\n  }\n}\n.form-label {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.form-control {\n  width: 100%;\n  padding: 0.5rem;\n  box-sizing: border-box;\n}\n\n.error-message {\n  color: red;\n  font-size: 0.875rem;\n  margin-top: -0.25rem; /* Prevent the error message from adding extra space */\n  margin-bottom: 0.5rem;\n  position: absolute; /* Position the error message absolutely */\n}\n\n.form-group {\n  position: relative; /* Necessary to position the error message within the form group */\n  margin-bottom: 1.5rem; /* Add space between form groups */\n}\n\ninput.error {\n  border-color: red;\n}/*# sourceMappingURL=style.css.map */","@import 'variable.scss'; \n@import 'mixins.scss'; \n@import url('https://fonts.googleapis.com/css2?family=Jost:wght@100;200;300;400;500;600;700&display=swap');\n*{padding: 0;margin: 0;box-sizing: border-box;font-family: 'Jost', sans-serif;}\n\nbody{\n    @include displayFlex;\n    flex-direction: column;\n    min-height: 100vh;    \n}\n\n.font{\n    &-9{font-size: 9px;}\n    &-10{font-size: 10px;}\n    &-11{font-size: 11px;}\n    &-12{font-size: 12px;}\n    &-13{font-size: 13px;}\n    &-14{font-size: 14px;}\n    &-15{font-size: 15px;}\n    &-16{font-size: 16px;}\n    &-17{font-size: 17px;}\n    &-18{font-size: 18px;}\n    &-19{font-size: 19px;}\n    &-20{font-size: 20px;line-height: 22px;}\n    &-21{font-size: 21px;}\n    &-22{font-size: 22px;}\n    &-23{font-size: 23px;}\n    &-24{font-size: 24px;}\n    &-25{font-size: 25px;}\n    &-26{font-size: 26px;}\n    &-27{font-size: 27px;}\n    &-28{font-size: 28px;}\n    &-29{font-size: 29px;}\n    &-30{font-size: 30px;}\n    &-31{font-size: 31px;}\n    &-32{font-size: 32px;}\n\n    &-100{font-weight: 100;}\n    &-300{font-weight: 300;}\n    &-400{font-weight: 400;}\n    &-500{font-weight: 500;}\n    &-600{font-weight: 600;}\n    &-700{font-weight: 700;}\n    &-900{font-weight: 900;}\n}\n\n.text{\n    &-dark-gray{color: $dark-gray;}\n}\n\n.flex-1{\n    @include flex-1;\n}\n\n.w{\n    &-140 {width: 140px;}\n    &-270 {\n        max-width: 270px;\n        width: 100%;\n    }\n    &-312{\n        max-width: 312px;\n        width: 100%;\n    }\n    &-800{\n        max-width: 800px;\n        width: 100%;\n    }\n    &-860{\n        max-width: 860px;\n        width: 100%;\n    }\n    &-1030{\n        max-width: 1030px;\n        width: 100%;\n    }\n}\n\n.height{\n    &-46{height: 46px;}\n}\n\n.min-height{\n    &-250{min-height: 250px;}\n}\n\n.bg-{\n    &grd-blue{\n        background: rgb(23,76,117);\n        background: -moz-radial-gradient(circle, rgba(23,76,117,1) 0%, rgba(9,50,83,1) 100%);\n        background: -webkit-radial-gradient(circle, rgba(23,76,117,1) 0%, rgba(9,50,83,1) 100%);\n        background: radial-gradient(circle, rgba(23,76,117,1) 0%, rgba(9,50,83,1) 100%);\n        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#174c75\",endColorstr=\"#093253\",GradientType=1);\n    }\n}\n\n\n.btn-green {\n    background: #5CAE48;\n    border-radius: 25px;\n    height: 36px;\n    @include displayFlex;\n    justify-content: center;\n    align-items: center;\n    color: $white;\n    &:hover {\n        background: #f8b018;\n      }\n}\n\n.wrapper {\n    @include displayFlex;\n    flex-direction: column;\n    min-height: 100vh;\n    background-color: #fff;\n    .dark-section{\n        @include flex-1;\n        background-color: rgb(11, 52, 84);     \n        background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/collage-building.svg);\n        background-repeat: no-repeat;\n        background-position: right top 30%;\n        background-blend-mode: multiply;\n        // clip-path: polygon(50% 0%, 100% 0, 100% 90%, 50% 100%, 0 90%, 0 0);\n        @media (max-width: 575px){\n            clip-path: polygon(50% 0%, 100% 0, 100% 93%, 50% 100%, 0 93%, 0 0);\n        }\n        &.student-img{\n            background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/gradute.svg);\n            background-position: bottom center;\n            background-size: 800px;\n            @media (max-width: 575px){\n                background-size: 450px;\n            }\n        }\n        &.bg-grd-blue{\n            background: rgb(23,76,117);\n            background: -moz-radial-gradient(circle, rgba(23,76,117,1) 0%, rgba(9,50,83,1) 100%);\n            background: -webkit-radial-gradient(circle, rgba(23,76,117,1) 0%, rgba(9,50,83,1) 100%);\n            background: radial-gradient(circle, rgba(23,76,117,1) 0%, rgba(9,50,83,1) 100%);\n            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#174c75\",endColorstr=\"#093253\",GradientType=1);\n        }\n        .logo {\n            background: #fff;\n            @include displayFlex;\n            @include borderRadius(0 0 10px 10px);\n            align-items: end;\n            justify-content: center;            \n            margin: 0 auto;\n            padding: 15px 30px;\n            max-width: 300px;\n            max-height: 230px;\n            min-width: 300px;\n\n            img {\n                height: 100%;\n                width: auto;\n                max-width: 100%;\n            }\n        }\n        .home-page-title {\n            font-size: 40px;\n            text-align: center;\n            @media (max-width: 1024px){\n                font-size: 30px;\n            }\n            @media (max-width: 767px){\n                font-size: 23px;\n            }\n        }\n        .sep {\n            width: 285px;\n            height: 2px;\n            background: #fff;\n            @include borderRadius(5px);\n            margin: 30px 0;\n            &.blue{\n                height: 2px;\n                background: #2B6B9F;\n                margin: 15px 0 45px;\n            }\n        }\n\n        .school-name {\n            font-size: 45px;\n            line-height: 50px;\n            text-align: center;\n            @media (max-width: 1024px){\n                font-size: 50px;\n                line-height: 60px;\n            }\n        }\n\n        .sub-school-tag {\n            font-size: 36px;\n            text-align: center;\n            line-height: 51px;font-weight: 500;\n            @media (max-width: 1024px){\n                font-size: 30px;\n                line-height: 34px;\n            }\n        }\n        \n        .header-icon {\n            margin-bottom: 22px;\n            @include displayFlex;\n            align-items: end;\n            position: relative;\n            &::before {\n                //content: '';\n                position: absolute;\n                width: 50px;\n                height: 50px;\n                background: #022642;\n                @include borderRadius(50%);\n                top: 0;\n                right: -10px;\n            }\n        }\n\n        .list {\n            margin: 0;\n            padding: 0;\n            list-style: none;\n            font-size: 30px;\n\n            @media (max-width: 575px){\n                font-size: 20px;\n                line-height: 30px;\n                padding-top: 40px;\n                padding-left:40px ;\n                padding-bottom: 50px;\n            }\n            li{\n                position: relative;\n                padding-left: 40px;\n                &::before{\n                    content: \"\";\n                    position: absolute;\n                    top: 9px;\n                    left: 0;\n                    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/green-check.svg) no-repeat left top/100%;\n                    width: 24px;\n                    height: 24px;\n                    @media (max-width: 575px){\n                        width: 20px;\n                        height: 20px;\n                        top: 5px;\n                    }\n                }\n                &:not(:last-child){\n                    margin-bottom: 30px;\n                }\n            }\n        }\n\n        .id-title {\n            font-size: 30px;\n            line-height: 45px;\n            font-weight: 600;\n        }\n\n        .form-title{\n            font-size: 32px;\n            line-height: 40px;\n            text-align: center;\n            font-weight: 600;\n            border: none;\n            color: #fff;\n            @media (max-width: 575px){\n                font-size: 20px;\n                line-height: 26px;\n                text-align: left;\n                font-weight: 500;\n            }\n        }\n\n        .form-label{\n            color: #fff;\n        }\n        \n        .white-label {\n            background: white;\n            width: 100%;\n            height: 60px;\n            @include borderRadius(35px);\n            max-width: 200px;\n            min-width: 200px;\n            padding: 0 25px;\n            color: black;\n            @include displayFlex;\n            align-items: center;\n            font-weight: 500;\n            font-size: 18px;\n            cursor: pointer;\n            i {\n                width: 13px;\n                height: 13px;\n                border: 1px solid #666666;\n                border-radius: 50%;\n                margin-right: 10px;\n            }\n        }\n\n        .form-check-input:checked + .white-label{\n            i {\n                border-color:$green-line;\n                background-color: $green-line;\n            }\n        }\n\n        .btn-submit {\n            width: 140px;\n            background: #5CAE48;\n            border-radius: 25px;\n            height: 36px;\n            @include displayFlex;\n            justify-content: center;\n            align-items: center;\n            color: $white;\n            &:hover {\n                background: #f8b018;\n              }\n        }\n\n    }\n\n        .footer-text-1 {\n            font-size: 36px;\n            line-height: 45px;\n            font-weight: 600;\n            text-align: center;\n            @media (max-width: 1024px){\n                font-size: 24px;line-height: 32px;\n            }\n        }\n    \n        .footer-text-2 {\n            font-size: 30px;\n            text-align: center;\n            @media (max-width: 1024px){\n                font-size: 24px;\n            }\n        }\n\n    .principal-wrap {\n        width: 281px;\n        position: relative;\n        margin: 0 auto;\n        .arrow-img {\n            position: absolute;\n            right: calc(100% + 10px);\n            bottom: 10px;\n        }\n        .btn-green {\n            width: 100%;\n            background: #5CAE48;\n            border-radius: 25px;\n            height: 44px;\n            @include displayFlex;\n            justify-content: center;\n            align-items: center;\n            color: $white;\n            &:hover {\n                background: #f8b018;\n              }\n        }\n    }\n\n.navigation_footer_wrap{\n    position: sticky;\n    bottom: 30px;\n    height: 0;\n    &:not(.homePageLink){\n        @media (max-width: 1366px){\n            bottom: 80px;\n        }\n        @media (min-width: 768px){\n            bottom: 80px;\n        }\n    }\n    \n    @media (max-width: 575px){\n        height: 50px;\n    }\n\n    .navigation_footer {\n        position: absolute;\n        left: 0;\n        right: 0;\n        width: calc(100% - 80px);\n        height: 55px;\n        margin: auto;\n        bottom: 0;\n        @include displayFlex;\n        justify-content: space-between;\n        max-width: 250px;\n        background: #fff;\n        @include borderRadius(25px);\n        align-items: center;\n        padding: 0 5px;\n        box-shadow: 0 0px 10px 1px #7676762e;\n\n        a {\n            width: auto;\n            height: 45px;\n            // background: url(../images/blue-arrow.svg) no-repeat 0 0;\n            @include displayFlex;\n            @include borderRadius(25px);\n            align-items: center;\n            padding: 0 20px;\n            background-color: $green-line;\n            color: $white;\n            text-decoration: none;\n            @include transition(all, 0.3s, ease-in-out);\n\n            &.btn-back {\n                i{\n                    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='white' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e\");\n                    background-repeat: no-repeat;\n                    background-position: center;\n                    background-size: 16px 12px;\n                    width: 10px;\n                    height: 20px;\n                    margin-right: 7px;\n                }\n            }\n            &.btn-next {\n                i{\n                    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='white' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e\");\n                    background-repeat: no-repeat;\n                    background-position: center;\n                    background-size: 16px 12px;\n                    width: 10px;\n                    height: 20px;\n                    margin-left: 7px;\n                }\n            }\n\n            &:hover{\n                background-color: #35911f;\n                text-decoration: none;\n            }\n\n            span{text-decoration: none;}\n        }\n\n\n    }\n    }\n}\n\n\n\n.left-graph {\n    position: absolute;\n    left: 0;\n    top: -40%;\n    width: 50%;\n    @media (max-width: 1500px){\n        top: -30%;\n    }\n    @media (max-width: 1250px){\n        top: -20%;\n    }\n    @media (max-width: 1100px){\n        top: -10%;\n    }\n    @media (max-width: 575px){\n        top: 0%;\n    }\n    img {\n        width: 100%;\n      }\n  }\n  .right-graph {\n    position: absolute;\n    right: 0;\n    top: -71%;\n    width: 50%;\n    @media (max-width: 1500px){\n        top: -50%;\n    }\n    @media (max-width: 1250px){\n        top: -40%;\n    }\n    @media (max-width: 1100px){\n        top: -30%;\n    }\n    @media (max-width: 575px){\n        top: -9%;\n        width: 70%;\n    }\n    img {\n        width: 100%;\n      }\n  }\n \n\n  .thanksTxt {\n\tfont-size: 100px;\n\tfont-weight: 700;\n\tmargin: 30px 0;\n\tfont-style: italic;\n    @media (max-width: 1100px){\n        font-size: 60px;\n        margin: 20px 0;\n    }\n    &-sub{\n        font-size: 36px;\n\t    font-weight: 600;\n        text-align: center;\n        @media (max-width: 575px){\n            font-size: 24px;\n        }\n        &-2{\n            font-size: 46px;\n            font-weight: 600;  \n            text-align: center;\n            @media (max-width: 575px){\n                font-size: 30px;\n            }\n        }\n        }\n    }\n    \n    @media (max-width: 1100px){\n        .thumb img {\n            max-width: 130px;\n        }\n    }\n    \n\n\n    .form-label {\n        display: inline-block;\n        margin-bottom: 0.5rem;\n        font-weight: 600;\n      }\n      \n      .form-control {\n        width: 100%;\n        padding: 0.5rem;\n        box-sizing: border-box;\n      }\n      \n      .error-message {\n        color: red;\n        font-size: 0.875rem;\n        margin-top: -0.25rem; /* Prevent the error message from adding extra space */\n        margin-bottom: 0.5rem;\n        position: absolute; /* Position the error message absolutely */\n      }\n      \n      .form-group {\n        position: relative; /* Necessary to position the error message within the form group */\n        margin-bottom: 1.5rem; /* Add space between form groups */\n      }\n      \n      \n    //   .col-12 {\n    //     width: 100%;\n    //   }\n      \n    //   .col-md-6 {\n    //     width: 48%;\n    //   }\n      \n      input.error {\n        border-color: red;\n      }","@import 'variable.scss'; \n\n@mixin flex-1() {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n\n@mixin flex-1() {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n@mixin flexNo($flexNo) {\n    -webkit-box-flex: $flexNo;\n    -moz-box-flex: $flexNo;\n    -webkit-flex: $flexNo;\n    -ms-flex: $flexNo;\n    flex: $flexNo;\n}\n\n@mixin displayFlex() {\n    display: -webkit-box; \n    display: -moz-box; \n    display: -ms-flexbox; \n    display: -webkit-flex; \n    display: flex;\n}\n\n@mixin flexWrap() {\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\t\n}\n\n@mixin threeColorGradientAngle($gradientangle: 125deg, $firstColor: #f3f9ff 0%, $secondColor:#f7fbff 44%, $thirdColor: #f0f7ff 100%) {\n    background: $firstColor;\n    background: -moz-linear-gradient($gradientangle,  $firstColor , $secondColor, $thirdColor); \n    background: -webkit-linear-gradient($gradientangle,  $firstColor, $secondColor, $thirdColor); \n    background: linear-gradient($gradientangle,  $firstColor, $secondColor, $thirdColor); \n}\n\n@mixin threeColorGradient($firstColor: #f3f9ff 0%, $secondColor:#f7fbff 44%, $thirdColor: #f0f7ff 100%) {\n    background: $firstColor;\n    background: -moz-linear-gradient(top,  $firstColor , $secondColor, $thirdColor); \n    background: -webkit-linear-gradient(top,  $firstColor, $secondColor, $thirdColor); \n    background: linear-gradient(to bottom,  $firstColor, $secondColor, $thirdColor); \n}\n\n@mixin twoColorGradient($firstColor: #f3f9ff 0%, $secondColor:#f7fbff 44%) {\n    background: $firstColor;\n    background: -moz-linear-gradient(top,  $firstColor , $secondColor); \n    background: -webkit-linear-gradient(top,  $firstColor, $secondColor); \n    background: linear-gradient(to bottom,  $firstColor, $secondColor); \n}\n\n@mixin mobileHeader(){\n    .step_header_wrap {\n        display: none;                            \n        @media (max-width: 767px){\n            &.mobile_header_wrap{\n                position: fixed;\n                bottom: 0;\n                z-index: 9;\n            }\n            &::before {\n                content: '';\n                position: absolute;\n                left: 0;\n                right: 0;\n                width: 50px;\n                height: 2px;\n                background: #727272;\n                margin: auto;\n                top: 20px;\n            }\n            @include displayFlex;\n            @include flexWrap;\n            @include threeColorGradient(#FDFEFF 0%, #EFF7FF 76%, #DBF1FF 100%);\n            @include transition(all, 0.1s ease-in-out);\n            justify-content: space-between;\n            margin: 0;\n                                           \n            box-shadow: 0px -7px 15px #00000026;\n            border-radius: 15px 15px 0px 0px;\n            padding: 30px 0px 0px 25px;\n            cursor: pointer;\n            width: 100%;\n            &.step_header_wrap_bg-beige {                \n                @include threeColorGradient(#FFFDF8 0%, #FEF6E4 76%, #FEECCB 100%);\n            }\n            &.bg-purple-gradient {\n                @include threeColorGradient(#EDEBFF 0%, #F6F5FF 76%, #F6F5FF 100%);\n            }\n            .mobile-step-block {\n                position: absolute;\n                left: 0;\n                right: 0;\n                top: 0;\n                bottom: 0;\n                z-index: 9;\n                &[aria-expanded=\"true\"] ~ .step_header_wrap_img {\n                    position: absolute;\n                    right: 0;\n                    border: 0;\n                    opacity: 0.2;\n                  }\n                  &[aria-expanded=\"false\"] + .step_header_wrap_title{\n                    .more {\n                        font-size: 16px;\n                    }\n                    .less{\n                        font-size: 0px;\n                    }\n                  }\n                   \n                    &[aria-expanded=\"true\"] + .step_header_wrap_title {\n                        .more {\n                            font-size: 0px;\n                        }\n                        .less{\n                            font-size: 16px;\n                        }\n                    }\n            }\n            \n            .step_header_wrap_title {\n                padding-top: 15px;\n                @include flex-1;\n                h2{\n                    font-size: 18px;\n                    font-weight: 600;\n                    margin-right: 15px;\n                    padding: 0;\n                }\n                .listed_points {\n                    margin-top: 20px;\n                    ul {\n                        margin: 0;\n                        padding: 0;\n                        list-style: none;\n                        li{\n                            font-size: 16px;\n                            font-weight: 400;\n                            margin-bottom: 15px;\n                            line-height: 19px;\n                            position: relative;\n                            padding: 0 0 0 10px;\n                            &::before{\n                                content: '';\n                                position: absolute;\n                                left: 0;\n                                top: 0px;\n                                width: 3px;\n                                height: 17px;\n                                background: #27A7DF;\n                                border-radius: 15px;\n                            }\n                        }\n                        &.beige-line{\n                            li{\n                                &::before{\n                                    background: #F8B018; \n                                }\n                            }\n                        }\n                        &.scholarship_detail_list {\n                            @include displayFlex();\n                            @include flexWrap();\n                            li:not(:last-child) {\n                                margin-right: 30px;\n                            }\n                        }\n                      }\n                }\n                .step_header_wrap_link {\n                    background: transparent;                                        \n                    color: #0b3454;\n                    text-decoration: none;\n                    padding: 3px 20px;\n                    display: inline-block;\n                    margin-bottom: 18px;\n                    font-weight: 500;\n                    border: 2px solid #0b3454;\n                    @include transition(all, 0.3s, ease-in-out);\n                    @include borderRadius(25px);\n                    span{\n                     @include transition(all, 0.3s, ease-in-out);\n                     &.less {\n                        font-size: 0;\n                      }\n                    }\n\n                }\n            }\n            img{\n                height: 128px;\n                @media (max-width:575px){\n                    height: auto;\n                    width: 125px;\n                }\n            }\n        }\n    }\n}\n\n@mixin formField() {    \n    max-width: 100%;\n    height: 45px;\n    border: 1px solid #b5c2cb;     \n    @include borderRadius(6px);\n}\n\n@mixin transition($what: all, $time:30s, $how: ease-in-out) {\n    -webkit-transition: $what $time $how;\n    -moz-transition:    $what $time $how;\n    -ms-transition:     $what $time $how;\n    -o-transition:      $what $time $how;\n    transition:         $what $time $how;\n}\n\n@mixin borderRadius($borderRadius) {\n    border-radius: $borderRadius;\n    -webkit-border-radius: $borderRadius;\n    -moz-border-radius: $borderRadius;\n    -ms-border-radius: $borderRadius;\n    -o-border-radius: $borderRadius;\n}\n\n@mixin translateX($translateX) {\n    transform: translateX($translateX);\n    -webkit-transform: translateX($translateX);\n    -moz-transform: translateX($translateX);\n    -ms-transform: translateX($translateX);\n    -o-transform: translateX($translateX);\n}\n\n@mixin rotate($rotate) {\n    transform: rotate($rotate);\n    -webkit-transform: rotate($rotate);\n    -moz-transform: rotate($rotate);\n    -ms-transform: rotate($rotate);\n    -o-transform: rotate($rotate);\n}\n\n@mixin opacity($opacity) {\n    opacity: $opacity;\n    $opacityIE: $opacity * 100;\n    filter: alpha(opacity=$opacityIE);\n}\n\n@mixin animation($animation...) {\n    -webkit-animation: $animation;\n    animation: $animation;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
